var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxInvoices({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-invoice",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    svg#freepik_stories-invoice:not(.animated) .animable {\n      opacity: 0;\n    }\n\n    svg#freepik_stories-invoice.animated #freepik--background-complete--inject-2 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) fadeIn;\n      animation-delay: 0s;\n    }\n\n    svg#freepik_stories-invoice.animated #freepik--Desk--inject-2 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0s;\n    }\n\n    svg#freepik_stories-invoice.animated #elehe9eooaqmk {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 1s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el42runked587 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.00510204081632653s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el3hb7ncf74kv {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.01020408163265306s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #els4hwy6jjx7o {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.015306122448979591s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el5fwrk8vgdlt {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.02040816326530612s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elfa8degbxhdb {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.02551020408163265s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el8b7yguugsyt {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.030612244897959183s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elsyfpognrm5 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.03571428571428571s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el0kv4ad46fgt {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.04081632653061224s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elkxa3yqf8jn {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.04591836734693877s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elqojzi83qei {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.0510204081632653s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elanhtn51vyng {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.05612244897959183s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el1t1va84iozf {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.061224489795918366s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el1ql8qy28058 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.06632653061224489s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el8pmeofs4stv {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.07142857142857142s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elpgyg8ubegn {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.07653061224489795s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elpy5vxiq1dq {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.08163265306122448s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #ele3jy6t0ynbj {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.08673469387755102s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elmo9z2nmcf7a {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.09183673469387754s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elb0esr59vmm {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.09693877551020408s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el3w2ojimzbx9 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.1020408163265306s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el9vn9o95bb6e {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.10714285714285714s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elyfeesraeav {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.11224489795918366s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elfsva30vgj64 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.1173469387755102s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elnxxqr687zj {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.12244897959183673s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elblee8cgf2hm {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.12755102040816327s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elhu3rhk858br {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.13265306122448978s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elzwe6p0a488s {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.1377551020408163s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elg8za2jzpfvj {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.14285714285714285s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el9wwigc5epkc {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.14795918367346939s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el8n5o18gsko {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.1530612244897959s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eld7zrsvxvq5 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.15816326530612243s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eldzuphw3zwd {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.16326530612244897s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eldyp6vueiu4g {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.1683673469387755s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el85gb6yoar12 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.17346938775510204s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elqx5i0mwwfn {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.17857142857142855s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elgcur4ulo7a7 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.18367346938775508s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el58uf0y16zbg {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.18877551020408162s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elpcgvcyzpu9 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.19387755102040816s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eltgme6wzn6z {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.19897959183673466s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eltlh3s1dz2pg {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.2040816326530612s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el596ornvqevv {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.20918367346938774s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eloi7ct9mcvz {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.21428571428571427s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elrgaovm1bzu {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.2193877551020408s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eljljcvu2zybc {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.22448979591836732s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elrzxffh65ri {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.22959183673469385s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eluxzh9943c0a {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.2346938775510204s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elk48v60hyn3e {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.23979591836734693s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eluhb19u7vohg {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.24489795918367346s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elplvz4k3e3p {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.24999999999999997s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elhq1cumu2rrb {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.25510204081632654s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elys9q4ma8s1 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.260204081632653s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el5acoktk0grr {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.26530612244897955s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el3bv8d8zsyat {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.2704081632653061s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eldawiwtlciji {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.2755102040816326s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el94ofna6avgl {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.28061224489795916s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el0bmmtitnumbv {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.2857142857142857s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el7s0p7d1u8wq {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.29081632653061223s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el4na7xtb8sst {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.29591836734693877s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el20l3x4rpbsu {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.3010204081632653s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el6mot3kcv67g {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.3061224489795918s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el3yqb2xlfqw9 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.3112244897959183s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el8u0dnlwqbmf {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.31632653061224486s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elwfnd8ph00y {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.3214285714285714s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #ellkowc2xr3c {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.32653061224489793s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elbc1whz8yhqw {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.33163265306122447s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eljuozxxzw3u {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.336734693877551s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el7hs0ivor7ur {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.34183673469387754s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elwfh9m1lc9d {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.3469387755102041s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elnnajgelszdi {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.35204081632653056s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el81dlhgltym {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.3571428571428571s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eld3splks82hk {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.36224489795918363s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #els7vwa8ji2lr {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.36734693877551017s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elat3mj1znxjc {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.3724489795918367s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elayzmixa6jfj {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.37755102040816324s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elctq26o0vjiu {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.3826530612244898s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el6v0ybcm0sx7 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.3877551020408163s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elbehua1osiht {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.39285714285714285s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elibw9ytnljs {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.39795918367346933s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el4yeyzehxv68 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.40306122448979587s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elrhjkiqpk3vs {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.4081632653061224s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elwbvyaid5jdk {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.41326530612244894s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el6lcrjyp576i {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.4183673469387755s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elg2nzzxq92qt {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.423469387755102s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el2gie1fbpn9s {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.42857142857142855s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eltwilpv7sgic {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.4336734693877551s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elsrtew1zwz7 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.4387755102040816s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el2b4nioi725j {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.4438775510204081s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elu5xbqinob1d {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.44897959183673464s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elqq0cw3ontrj {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.4540816326530612s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eluo9qolhkny {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.4591836734693877s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elvr3xmbeg7ge {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.46428571428571425s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elfb8lmnxv8ao {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.4693877551020408s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el36hua6w4aqm {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.4744897959183673s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el3x1o8xboymc {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.47959183673469385s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el3b9rd2c9dgn {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.4846938775510204s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el2vyhksthar8 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.4897959183673469s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eld5g9qco8k9r {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.4948979591836734s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elixccp88gud8 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.49999999999999994s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elzf1me86eogi {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.5051020408163265s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elgaczpmg6n7v {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.5102040816326531s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el83efacdlx6 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.5153061224489796s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elswmz8ipq4vi {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.520408163265306s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elcg2y3wz0ivm {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.5255102040816326s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elz75qxhiu1ro {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.5306122448979591s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el85hnbo82ltv {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.5357142857142857s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elad5rrltttfm {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.5408163265306122s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el5bls53999u4 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.5459183673469388s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elf3xfvqyauj4 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.5510204081632653s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elv55gc1i5069 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.5561224489795918s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elrpai2516l1 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.5612244897959183s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elbrg07vrw7is {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.5663265306122448s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elmemuhj7r8fm {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.5714285714285714s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elvglw6i13q8 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.5765306122448979s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elvnkev3r8san {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.5816326530612245s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elb4vkgmktyth {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.586734693877551s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el3xezurn5ys6 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.5918367346938775s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elr9pgwmhxm8c {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.596938775510204s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elqe7s8frl2wi {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.6020408163265306s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elsce6h92l45 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.6071428571428571s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elzhw8g3jyg8j {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.6122448979591836s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el0odko5q0aly {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.6173469387755102s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elusfcn85hsf {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.6224489795918366s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eleyfuztdddt {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.6275510204081632s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el8endwey8dhr {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.6326530612244897s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elkfuvkotf2ib {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.6377551020408163s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elrtro00q69uo {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.6428571428571428s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elaxgh2ttayo8 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.6479591836734694s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elzoz7j7iizp {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.6530612244897959s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elny94sud9c5 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.6581632653061223s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elw2njqbdm7e {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.6632653061224489s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el7kz9x334k9p {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.6683673469387754s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el7bo3sjof1u3 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.673469387755102s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el7b7xsnm0kna {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.6785714285714285s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elbydw6723nff {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.6836734693877551s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el7rm1s4oud5w {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.6887755102040816s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el9bayy6is95 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.6938775510204082s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elj7grqeg22dh {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.6989795918367346s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elmgpw6zy0kx {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.7040816326530611s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el5yrt6qay4d8 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.7091836734693877s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el68cnv06c1kc {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.7142857142857142s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elib18fk9mvxq {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.7193877551020408s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el0xojyrvr0tl9 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.7244897959183673s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el0488a8pq1wmt {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.7295918367346939s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eldeliannjjn4 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.7346938775510203s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elru9icwuowx8 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.7397959183673469s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #ellj4su570d3r {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.7448979591836734s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el0hozc6ksvm9q {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.7499999999999999s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el3mis38rqcz8 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.7551020408163265s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el8325ofdk29s {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.760204081632653s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elof9gcpymprr {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.7653061224489796s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elvuzb9lz4de {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.770408163265306s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el36m077x1m92 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.7755102040816326s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elb8ayj2za9l {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.7806122448979591s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el5exynjzel2p {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.7857142857142857s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el92l10cxueb5 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.7908163265306122s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elp8rd4kynu8s {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.7959183673469387s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elkelw2o304xk {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.8010204081632653s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elz1t0e07n80m {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.8061224489795917s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eld6x38tgue5o {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.8112244897959183s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elypadzgaq09 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.8163265306122448s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eljlegj41hrpi {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.8214285714285714s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elh4w1j1oqvh8 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.8265306122448979s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elje28h1t4qt {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.8316326530612245s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elzbiotoasdcm {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.836734693877551s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eljlkiqvr6ie {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.8418367346938774s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elgjmtuyfl4xn {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.846938775510204s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elup1uba2wp3m {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.8520408163265305s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eleogo847m89c {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.8571428571428571s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eluynl0bmeibk {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.8622448979591836s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el89zavm17cm {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.8673469387755102s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elebgskoi4gos {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.8724489795918366s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el8sss5ft1sio {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.8775510204081632s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elhuqpjki6tjr {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.8826530612244897s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elrqfexnspgbr {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.8877551020408162s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elgm5kat9pm6 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.8928571428571428s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elp84p1gdw73n {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.8979591836734693s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elvunpc17lboi {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.9030612244897959s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el5jz4lp63424 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.9081632653061223s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eloydg9ozdq9a {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.9132653061224489s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #els2td79bqyyl {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.9183673469387754s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elqbg79x4x8u9 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.923469387755102s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eln6nf01o01wl {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.9285714285714285s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el94cy1ork7v6 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.933673469387755s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el0izvcjutl7t5 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.9387755102040816s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elmxvvlfq2fxr {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.943877551020408s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el4a9788cvsrj {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.9489795918367346s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el9yldyoz71n {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.9540816326530611s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elecvtzrf5yje {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.9591836734693877s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elrfzjy42u8u {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.9642857142857142s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eldt8wzvj7and {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.9693877551020408s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elpumt5lmfzgb {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.9744897959183673s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el1i1zyevd0cz {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.9795918367346939s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el8gupb9si6vr {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.9846938775510203s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el8j40bkhive {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.9897959183673468s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el8bykb1utb {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 0.9948979591836734s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #freepik--Invoices--inject-2 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown;\n      animation-delay: 1s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #freepik--speech-bubble--inject-2 {\n      animation: 1.5s Infinite linear heartbeat;\n      animation-delay: 0s;\n    }\n\n    svg#freepik_stories-invoice.animated #el3ha1jg4lieg {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 2s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el06hghjlhqmgh {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.022727272727272728s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el2xwa7aghq1l {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.045454545454545456s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elm6z6lef677 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.06818181818181818s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elcxxhtw1xfaa {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.09090909090909091s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elzozkr0w77ar {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.11363636363636365s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elow58qg5ozg {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.13636363636363635s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el9g0e7s6ag9 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.1590909090909091s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elor1opxdbq2a {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.18181818181818182s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el3hzwcvt3meb {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.20454545454545456s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elo2ki3bjj41 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.2272727272727273s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elbu3dtc1xf9a {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.25s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elqbjopjday2b {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.2727272727272727s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eldkmbxx9cfse {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.29545454545454547s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eldrx28rozlpe {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.3181818181818182s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elpnmmmxo3paq {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.34090909090909094s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elluga1f972gk {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.36363636363636365s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elid2r1uq3e5o {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.38636363636363635s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elut1hvb8udod {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.4090909090909091s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elpqf2k55hrse {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.4318181818181818s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el3m4936e3k0b {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.4545454545454546s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el61uq597h8o7 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.4772727272727273s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el5jrd0fi09ij {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.5s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elogqqbz069ha {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.5227272727272727s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elih6ibkjp3sf {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.5454545454545454s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el1a56vpyteep {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.5681818181818182s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elvkx35ezo7oh {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.5909090909090909s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el9g39gbnlbi {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.6136363636363636s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elmg4lws6ts4 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.6363636363636364s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el0s1zs1ghkgfb {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.6590909090909091s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elh62208toynb {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.6818181818181819s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elnvdw5mjf4dq {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.7045454545454546s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elfp3cyk9bwg8 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.7272727272727273s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el4hxrh9201g2 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.75s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el9n4h8qwg14q {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.7727272727272727s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el1ivyht9cfuo {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.7954545454545455s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el4f8u8jdye6 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.8181818181818182s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el7haa8xdntp5 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.8409090909090909s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elvemsvc0lju {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.8636363636363636s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el5vrw3yobuc2 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.8863636363636364s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el3bpxz3l07tq {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.9090909090909092s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #el2i70oedr07j {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.9318181818181819s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #elg72ue7p6i3c {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.9545454545454546s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #eljgbqgupolql {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0.9772727272727273s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #freepik--Plant--inject-2 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 2s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-invoice.animated #freepik--Calculator--inject-2 {\n      animation: 1.5s Infinite linear wind;\n      animation-delay: 0s;\n    }\n\n    svg#freepik_stories-invoice.animated #freepik--Character--inject-2 {\n      animation: 1.5s Infinite linear wind;\n      animation-delay: 0s;\n    }\n\n    @keyframes fadeIn {\n      0% {\n        opacity: 0;\n      }\n\n      100% {\n        opacity: 1;\n      }\n    }\n\n    @keyframes slideUp {\n      0% {\n        opacity: 0;\n        transform: translateY(30px);\n      }\n\n      100% {\n        opacity: 1;\n        transform: inherit;\n      }\n    }\n\n    @keyframes slideDown {\n      0% {\n        opacity: 0;\n        transform: translateY(-30px);\n      }\n\n      100% {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    }\n\n    @keyframes heartbeat {\n      0% {\n        transform: scale(1);\n      }\n\n      10% {\n        transform: scale(1.1);\n      }\n\n      30% {\n        transform: scale(1);\n      }\n\n      40% {\n        transform: scale(1);\n      }\n\n      50% {\n        transform: scale(1.1);\n      }\n\n      60% {\n        transform: scale(1);\n      }\n\n      100% {\n        transform: scale(1);\n      }\n    }\n\n    @keyframes wind {\n      0% {\n        transform: rotate(0deg);\n      }\n\n      25% {\n        transform: rotate(1deg);\n      }\n\n      75% {\n        transform: rotate(-1deg);\n      }\n    }\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2",
    className: "animable animator-active",
    style: {
      transformOrigin: "238.01px 252.685px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "447.87 49.08 447.87 177.71 281.72 177.71 275.74 49.98 447.87 49.08",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "361.805px 113.395px"
    },
    id: "elo5rowh25mem",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4inm7084jg6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.86,
    y: 30.69,
    width: 127.89,
    height: 166.15,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "358.805px 113.765px",
      transform: "rotate(-90deg)"
    },
    className: "animable",
    id: "elpvr21a2gr3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M442.52,178.35H275.1V49.19H442.52Zm-166.15-1.27H441.25V50.46H276.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "358.81px 113.77px"
    },
    id: "elbgw0avv5b89",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.73,
    y: 62.97,
    width: 130.16,
    height: 97.91,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "358.81px 111.925px"
    },
    id: "elb1rd9ltq36t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.89,63h-.63l-1.83,0-7.09,0-26.7.08-93.91.14L294,63c0,29.36,0,62.7,0,97.9h0l-.33-.33,130.16.06-.27.27c.06-29.59.11-54,.14-71.1,0-8.54.05-15.22.07-19.8,0-2.27,0-4,0-5.21s0-1.8,0-1.8,0,.58,0,1.74,0,2.91,0,5.17c0,4.55,0,11.22.07,19.73,0,17.11.08,41.61.14,71.27v.27h-.27l-130.16.06h-.33v-.33h0c0-35.2,0-68.54,0-97.9v-.3h.3l94.11.15,26.62.08,7,0,1.8,0C423.69,63,423.89,63,423.89,63Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "358.6px 111.965px"
    },
    id: "eljpitg03kkni",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.74,49.53a16.23,16.23,0,0,1,2.81,1.72c1.68,1.14,4,2.74,6.48,4.59s4.71,3.59,6.27,4.89A15.45,15.45,0,0,1,293.73,63,18,18,0,0,1,291,61.1l-6.37-4.73-6.37-4.74A16.34,16.34,0,0,1,275.74,49.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "284.735px 56.265px"
    },
    id: "elyx9ifalry2f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.88,49.82c.11.15-3.83,3.21-8.8,6.84S424,63.11,423.89,63s3.83-3.21,8.8-6.84S441.78,49.67,441.88,49.82Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "432.885px 56.4087px"
    },
    id: "elhqb21fks77b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 441.88,
    y1: 177.71,
    x2: 423.23,
    y2: 160.88,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "432.555px 169.295px"
    },
    id: "el3mt24njxhuq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.23,160.88c.12-.14,4.4,3.52,9.55,8.17s9.23,8.53,9.1,8.66-4.39-3.52-9.55-8.17S423.11,161,423.23,160.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "432.555px 169.295px"
    },
    id: "el9oshgrcd5r4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.74,177.71c-.13-.13,3.76-3.84,8.68-8.28s9-7.93,9.13-7.79-3.77,3.84-8.69,8.28S275.86,177.85,275.74,177.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "284.645px 169.675px"
    },
    id: "eloeygl1vn38",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.94,81c0,.19-12.87.34-28.75.34s-28.76-.15-28.76-.34,12.87-.34,28.76-.34S388.94,80.83,388.94,81Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "360.185px 81px"
    },
    id: "el97msaexly86",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.9,113.39c0,.19-19.29.35-43.09.35s-43.09-.16-43.09-.35,19.29-.34,43.09-.34S401.9,113.2,401.9,113.39Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "358.81px 113.395px"
    },
    id: "els2x44h6u7d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.9,121.39c0,.19-19.29.34-43.09.34s-43.09-.15-43.09-.34,19.29-.34,43.09-.34S401.9,121.2,401.9,121.39Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "358.81px 121.39px"
    },
    id: "elnz4makqmkc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.45,97.12A5.15,5.15,0,0,1,316.93,92a5.27,5.27,0,0,1,4.28,1.88l-1.79,1.62a3,3,0,0,0-2.35-1.17,2.85,2.85,0,0,0,0,5.69,3,3,0,0,0,2.35-1.17l1.79,1.62a5.27,5.27,0,0,1-4.28,1.88A5.15,5.15,0,0,1,311.45,97.12Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "316.33px 97.175px"
    },
    id: "elfkjdcuuulhu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.46,99.93v2.17h-8V92.15h7.81v2.17h-5V96h4.42v2.11h-4.42v1.82Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "326.46px 97.125px"
    },
    id: "elja7mer6ta9d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.37,99.46h-1.53v2.64H332V92.15h4.55c2.72,0,4.43,1.4,4.43,3.68A3.28,3.28,0,0,1,339.05,99l2.15,3.13h-3Zm0-5.09h-1.56v2.91h1.56c1.17,0,1.75-.54,1.75-1.45S337.57,94.37,336.4,94.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "336.6px 97.14px"
    },
    id: "eldhn0tf2dc7u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.53,94.38h-3.06V92.15h8.91v2.23h-3v7.72h-2.81Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "345.925px 97.125px"
    },
    id: "elvgkuj3g515",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.44,92.15h2.81v9.95h-2.81Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "352.845px 97.125px"
    },
    id: "elzj8temf1e7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.08,94.32v2.19h4.39v2.18h-4.39v3.41h-2.82V92.15h7.81v2.17Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "360.165px 97.125px"
    },
    id: "elo0pd2jrd7am",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.39,92.15h2.82v9.95h-2.82Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "366.8px 97.125px"
    },
    id: "eljaosmcfmht",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.7,97.12A5.15,5.15,0,0,1,375.18,92a5.27,5.27,0,0,1,4.28,1.88l-1.79,1.62a3,3,0,0,0-2.35-1.17,2.85,2.85,0,0,0,0,5.69,3,3,0,0,0,2.35-1.17l1.79,1.62a5.27,5.27,0,0,1-4.28,1.88A5.15,5.15,0,0,1,369.7,97.12Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.58px 97.175px"
    },
    id: "elmich0ca53j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.21,100.17H383l-.78,1.93h-2.87l4.39-9.95h2.77l4.41,9.95H388Zm-.82-2.08-1.28-3.18-1.28,3.18Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "385.135px 97.125px"
    },
    id: "elcyfzb08t00n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.34,94.38h-3V92.15h8.91v2.23h-3v7.72h-2.82Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "394.795px 97.125px"
    },
    id: "elcmk6rv6xopl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.25,99.93v2.17h-8V92.15h7.8v2.17h-5V96h4.43v2.11H403v1.82Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "404.25px 97.125px"
    },
    id: "el2kehhhffs6l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.11,141.28a10,10,0,1,1-10-10A10,10,0,0,1,370.11,141.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "360.11px 141.28px"
    },
    id: "elu6wlolzoh3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.08,151.34a10.06,10.06,0,1,1,10.06-10.06A10.08,10.08,0,0,1,360.08,151.34Zm0-20.06a10,10,0,1,0,10,10A10,10,0,0,0,360.08,131.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "360.08px 141.28px"
    },
    id: "elpfuqf0dxeop",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.69,141.28c0,.19-5.41.34-12.08.34s-12.08-.15-12.08-.34,5.4-.34,12.08-.34S339.69,141.09,339.69,141.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "327.61px 141.28px"
    },
    id: "ellqqg519ahh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.94,141.28c0,.19-6.06.34-13.52.34s-13.51-.15-13.51-.34,6-.34,13.51-.34S405.94,141.09,405.94,141.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "392.425px 141.28px"
    },
    id: "el4zacvoqkbb5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.45,139.39a2.67,2.67,0,0,1-.15-.83,9,9,0,0,1,.14-2.41,8.69,8.69,0,0,1,1.52-3.53,2.05,2.05,0,0,1,1-.7,1.57,1.57,0,0,1,1.32.28,2.4,2.4,0,0,1,.84,2.62,7.77,7.77,0,0,1-1.47,2.61,13.18,13.18,0,0,1-2.22,2.34,6.59,6.59,0,0,1-3.18,1.47,5.13,5.13,0,0,1-3.65-.82,3.93,3.93,0,0,1-1.6-3.57,11.94,11.94,0,0,1,1.08-3.9,4.55,4.55,0,0,1,1.32-1.72,2.86,2.86,0,0,1,2.21-.55,2.13,2.13,0,0,1,1.65,1.64,4.45,4.45,0,0,1-.13,2.27,13.85,13.85,0,0,1-2,3.82,8.67,8.67,0,0,1-3.19,2.74,6.47,6.47,0,0,1-4.05.51,4.81,4.81,0,0,1-3.21-2.26,6.36,6.36,0,0,1-.85-3.62,9.43,9.43,0,0,1,.89-3.36c.45-1,1-2.12,2.22-2.44a1.49,1.49,0,0,1,1.54.71,3.29,3.29,0,0,1,.4,1.49,9.75,9.75,0,0,1-1.2,4.93,9.94,9.94,0,0,1-2.4,3,9.06,9.06,0,0,1-2,1.31,3.59,3.59,0,0,1-.79.29,14.06,14.06,0,0,0,2.64-1.8,10.19,10.19,0,0,0,2.23-2.95,9.54,9.54,0,0,0,1.05-4.74,2.77,2.77,0,0,0-.34-1.24,1,1,0,0,0-1-.46,2,2,0,0,0-1.07.79,6.52,6.52,0,0,0-.74,1.36,6.93,6.93,0,0,0,0,6.42,4.13,4.13,0,0,0,2.8,2,5.75,5.75,0,0,0,3.63-.48c2.31-1.11,3.91-3.59,4.8-6.14a3.81,3.81,0,0,0,.13-1.91,1.48,1.48,0,0,0-1.13-1.15,2.22,2.22,0,0,0-1.67.43,3.9,3.9,0,0,0-1.11,1.47,11.15,11.15,0,0,0-1,3.64,3.32,3.32,0,0,0,1.32,3,4.51,4.51,0,0,0,3.2.73,6.09,6.09,0,0,0,2.91-1.31,12.51,12.51,0,0,0,2.15-2.22,7.48,7.48,0,0,0,1.43-2.41,2,2,0,0,0-.63-2.15,1.28,1.28,0,0,0-1.82.32,8.61,8.61,0,0,0-1.55,3.33A12.53,12.53,0,0,0,333.45,139.39Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "327.859px 135.871px"
    },
    id: "ely2ddvqpkbjn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.77,137.78s-.08.06-.26.15-.44.21-.8.36a27.36,27.36,0,0,1-3.2,1.1,30.78,30.78,0,0,1-8.67,1.1c-1.19,0-2.48-.24-3.73-.1a2.6,2.6,0,0,0-1.62.83,1.54,1.54,0,0,0-.2,1.73,8.86,8.86,0,0,0,1.23,1.75c.47.59,1,1.17,1.49,1.75s1.06,1.15,1.62,1.73a5.63,5.63,0,0,0,1.83,1.41,1.65,1.65,0,0,0,1.91-.67,3.62,3.62,0,0,0,.57-2.3,54.63,54.63,0,0,1,2.51-23l.29-.86.35.83a19,19,0,0,1,1.35,6,19.74,19.74,0,0,1-1.37,8.35,19,19,0,0,1-1.95,3.64,5.88,5.88,0,0,1-3.15,2.66,1.93,1.93,0,0,1-2.07-.73,3.94,3.94,0,0,1-.55-2,21.8,21.8,0,0,1,.12-3.8,21.21,21.21,0,0,1,2.09-6.89l.22-.43.29.39a4.62,4.62,0,1,1-7.06-.22,2.46,2.46,0,0,1,1.15-.8,1.23,1.23,0,0,1,1.35.37,1.89,1.89,0,0,1,.33,1.27,4,4,0,0,1-.26,1.16,14.78,14.78,0,0,1-3.7,5.79,15.5,15.5,0,0,1-1.4,1.17,3.38,3.38,0,0,1-.53.33,3.43,3.43,0,0,1,.47-.41c.31-.27.78-.66,1.33-1.22a15,15,0,0,0,3.5-5.78,2.36,2.36,0,0,0,0-2.06c-.45-.57-1.38-.18-1.88.46A4.32,4.32,0,0,0,384,136a4.07,4.07,0,1,0,6.57-4.79l.51,0A20.34,20.34,0,0,0,389,141.5a3.35,3.35,0,0,0,.43,1.66,1.28,1.28,0,0,0,1.39.48,3.67,3.67,0,0,0,1.53-.91,10.11,10.11,0,0,0,1.22-1.49,18.42,18.42,0,0,0,1.87-3.51,18.91,18.91,0,0,0,1.32-8.06,18.29,18.29,0,0,0-1.3-5.76l.64,0a54.47,54.47,0,0,0-2.55,22.73,4.16,4.16,0,0,1-.71,2.67,2.63,2.63,0,0,1-1.13.87,2.15,2.15,0,0,1-1.44,0,5.82,5.82,0,0,1-2-1.57c-.57-.58-1.11-1.17-1.63-1.76s-1-1.18-1.49-1.78a8.9,8.9,0,0,1-1.28-1.88,2,2,0,0,1,.29-2.24,3,3,0,0,1,1.93-1,8.69,8.69,0,0,1,2,0c.62.06,1.23.1,1.82.11a30,30,0,0,0,3.33-.07,31.08,31.08,0,0,0,5.26-.85c1.42-.36,2.5-.72,3.22-1S402.76,137.76,402.77,137.78Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "391.86px 136.532px"
    },
    id: "elnq24wbtu6yk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.59 386.49 448.83 455.74 413.08 455.74 406.04 386.49 455.59 386.49",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "430.815px 421.115px"
    },
    id: "elmr0irtviiu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbfk2953a2m8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 401.82,
    y: 381.42,
    width: 59.11,
    height: 5.07,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "431.375px 383.955px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el2si5lougz9i"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "449.68 372.7 455.59 382.55 408.58 382.55 410.83 372.7 449.68 372.7",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "432.085px 377.625px"
    },
    id: "elevxeatgu7cg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "453.31 409.81 450.9 434.52 410.92 434.52 408.41 409.81 453.31 409.81",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "430.86px 422.165px"
    },
    id: "elw6efu8htjil",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.73,429.11a11.28,11.28,0,0,1,1.85-6.11c1-1.55,2.2-2.89,3.18-4.22a13,13,0,0,0,2.06-3.9,7.11,7.11,0,0,0,.32-1.72l.27.15a6.22,6.22,0,0,1,2.61,4.08,11.78,11.78,0,0,1-.22,4.94,10.7,10.7,0,0,1-2.6,5.24A7.16,7.16,0,0,1,427,429.5,4.89,4.89,0,0,1,425.73,429.11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "430.957px 421.381px"
    },
    id: "ellgvw5zfd7uq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.7,423.68A20.55,20.55,0,0,1,424,417.2c.87-2,2.56-3.95,4.73-4.39a5.5,5.5,0,0,1,3.43.17,7.5,7.5,0,0,1-.42,1.74,13.49,13.49,0,0,1-2.11,3.66c-1,1.28-2.2,2.61-3.25,4.23a11.49,11.49,0,0,0-1.82,5.11c0,.37,0,.73-.06,1.09a3.62,3.62,0,0,1-1.35-1.37A6.57,6.57,0,0,1,422.7,423.68Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "427.381px 420.712px"
    },
    id: "el2rm6arc4dh3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.25,343.64l3,55a3.71,3.71,0,0,0,3.68,3.51l98.92.73a3.71,3.71,0,0,0,3.74-3.68l.31-42.8a3.7,3.7,0,0,0-3.7-3.73l-60.84-.06a3.67,3.67,0,0,1-2.62-1.09L127.23,341a3.67,3.67,0,0,0-2.6-1.08L99,339.73A3.71,3.71,0,0,0,95.25,343.64Z",
    style: {
      fill: "#9B6EF3",
      transformOrigin: "150.072px 371.305px"
    },
    id: "el3h7vr1xw4c3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elj59aes2lw4f"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "150.072px 371.305px"
    },
    className: "animable",
    id: "eliumf74q9ul"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.25,343.64l3,55a3.71,3.71,0,0,0,3.68,3.51l98.92.73a3.71,3.71,0,0,0,3.74-3.68l.31-42.8a3.7,3.7,0,0,0-3.7-3.73l-60.84-.06a3.67,3.67,0,0,1-2.62-1.09L127.23,341a3.67,3.67,0,0,0-2.6-1.08L99,339.73A3.71,3.71,0,0,0,95.25,343.64Z",
    id: "elpnybzyv7a9",
    className: "animable",
    style: {
      transformOrigin: "150.072px 371.305px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el9n5py3zdjui"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96.65,
    y: 345.77,
    width: 108.09,
    height: 64.59,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "150.695px 378.065px",
      transform: "rotate(0.42deg)"
    },
    className: "animable",
    id: "eliz4od5huwxs"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.24,351.11,96,418.52a2.4,2.4,0,0,0,2.36,2.12l105.33.77a2.39,2.39,0,0,0,2.4-2.18l5.79-67.32a2.38,2.38,0,0,0-2.36-2.59l-118.89-.87A2.39,2.39,0,0,0,88.24,351.11Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "150.057px 384.93px"
    },
    id: "ely7rk3vkuxe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.15,333.27l3,55a3.7,3.7,0,0,0,3.68,3.51l98.92.73a3.72,3.72,0,0,0,3.74-3.69l.31-42.79a3.72,3.72,0,0,0-3.71-3.74l-60.84-.05a3.7,3.7,0,0,1-2.62-1.09L98.13,330.63a3.74,3.74,0,0,0-2.6-1.09l-25.65-.18A3.7,3.7,0,0,0,66.15,333.27Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "120.972px 360.935px"
    },
    id: "eluz50ij7oma",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elga9sucwcdzn"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.54,
    y: 335.4,
    width: 108.09,
    height: 64.59,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "121.585px 367.695px",
      transform: "rotate(0.42deg)"
    },
    className: "animable",
    id: "eln16bcudrevc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.14,340.74l7.76,67.41a2.38,2.38,0,0,0,2.35,2.11l105.34.78a2.4,2.4,0,0,0,2.39-2.19l5.8-67.31a2.38,2.38,0,0,0-2.36-2.59l-118.89-.87A2.39,2.39,0,0,0,59.14,340.74Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "120.957px 374.56px"
    },
    id: "eladzjg4838sj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.35,346.14l3,55A3.72,3.72,0,0,0,40,404.63l98.92.72a3.71,3.71,0,0,0,3.74-3.68l.31-42.79a3.71,3.71,0,0,0-3.71-3.74l-60.84-.06A3.73,3.73,0,0,1,75.82,354L65.33,343.5a3.69,3.69,0,0,0-2.6-1.08l-25.65-.19A3.71,3.71,0,0,0,33.35,346.14Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "88.1574px 373.79px"
    },
    id: "eluw9e76tnhap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elc4o8unahj3d"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.74,
    y: 348.27,
    width: 108.09,
    height: 64.59,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "88.785px 380.565px",
      transform: "rotate(0.42deg)"
    },
    className: "animable",
    id: "el9dibtsk27vf"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.34,353.61,34.1,421a2.39,2.39,0,0,0,2.35,2.12l105.34.77a2.38,2.38,0,0,0,2.39-2.18l5.8-67.32a2.39,2.39,0,0,0-2.36-2.59L28.73,351A2.39,2.39,0,0,0,26.34,353.61Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "88.1591px 387.445px"
    },
    id: "elc9qcgntz6bd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.09,362.78v93.51H150V362.78Zm84,23.73H66a6.91,6.91,0,1,1,0-13.81h33a6.91,6.91,0,0,1,0,13.81Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "82.545px 409.535px"
    },
    id: "elpflpayzofvm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,362.78v93.51h72.72V362.78Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "186.36px 409.535px"
    },
    id: "elfojpivsyfht",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-2",
    className: "animable",
    style: {
      transformOrigin: "245.965px 456.275px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.64,456.29c0,.14-103.28.26-230.66.26s-230.69-.12-230.69-.26S118.56,456,246,456,476.64,456.15,476.64,456.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "245.965px 456.275px"
    },
    id: "elye9dbpm9grm",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Invoices--inject-2",
    className: "animable",
    style: {
      transformOrigin: "118.35px 150.89px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "183.82 251.79 37.85 251.79 37.73 65.89 183.88 65.89 183.82 251.79",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "110.805px 158.84px"
    },
    id: "elehe9eooaqmk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.67,
    y: 65.23,
    width: 146.15,
    height: 35.78,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "110.745px 83.12px"
    },
    id: "el42runked587",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.97,
    y: 95.6,
    width: 55.7,
    height: 9.01,
    style: {
      fill: "#9B6EF3",
      transformOrigin: "72.82px 100.105px"
    },
    id: "el3hb7ncf74kv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.97,
    y: 140.48,
    width: 130.57,
    height: 12.94,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "110.255px 146.95px"
    },
    id: "els4hwy6jjx7o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.97,
    y: 153.41,
    width: 130.57,
    height: 12.94,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "110.255px 159.88px"
    },
    id: "el5fwrk8vgdlt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.93,98.64h.25V101h-.25Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "51.055px 99.82px"
    },
    id: "elfa8degbxhdb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.54,100v1H53.3v-1a.5.5,0,0,0-.53-.57.59.59,0,0,0-.63.64V101H51.9V99.23h.23v.32a.77.77,0,0,1,.68-.34A.68.68,0,0,1,53.54,100Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "52.7247px 100.104px"
    },
    id: "el8b7yguugsyt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.66,99.23l-.8,1.78h-.24l-.79-1.78h.25l.67,1.51.67-1.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "54.745px 100.12px"
    },
    id: "elsyfpognrm5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.76,100.12a.91.91,0,1,1,1.81,0,.91.91,0,0,1-1.81,0Zm1.57,0a.66.66,0,1,0-.66.69A.65.65,0,0,0,57.33,100.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "56.665px 100.025px"
    },
    id: "el0kv4ad46fgt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,98.66a.18.18,0,0,1,.18-.17.17.17,0,0,1,.17.17.17.17,0,0,1-.17.18A.18.18,0,0,1,58,98.66Zm.06.57h.24V101h-.24Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "58.1751px 99.745px"
    },
    id: "elkxa3yqf8jn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8,100.12a.87.87,0,0,1,.91-.91.78.78,0,0,1,.7.35l-.18.13a.61.61,0,0,0-.52-.27.7.7,0,0,0,0,1.39.6.6,0,0,0,.52-.26l.18.12a.78.78,0,0,1-.7.35A.87.87,0,0,1,58.8,100.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "59.6045px 100.115px"
    },
    id: "elqojzi83qei",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4,100.19H60.91a.66.66,0,0,0,.7.62.73.73,0,0,0,.55-.23l.13.15a.86.86,0,0,1-.68.29.88.88,0,0,1-.94-.9.86.86,0,0,1,.87-.91.85.85,0,0,1,.86.91ZM60.91,100h1.26a.61.61,0,0,0-.63-.59A.62.62,0,0,0,60.91,100Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "61.5353px 100.116px"
    },
    id: "elanhtn51vyng",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.09,99.47l-.09.71h.48v.18H66l-.07.65h-.19l.08-.65H65.1L65,101h-.18l.07-.65h-.48v-.18h.51l.08-.71h-.48v-.19h.51l.08-.64h.18l-.08.64h.7l.08-.64h.18l-.08.64h.48v.19Zm-.19,0h-.69l-.09.71h.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "65.49px 99.82px"
    },
    id: "el1t1va84iozf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.43,100.33c0,.39-.29.7-.86.7a1.21,1.21,0,0,1-.85-.31l.12-.19a1,1,0,0,0,.73.27c.4,0,.61-.18.61-.47s-.2-.47-.64-.47h-.17v-.18l.66-.83H66.82v-.21h1.52v.17l-.67.84C68.18,99.68,68.43,100,68.43,100.33Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "67.575px 99.8353px"
    },
    id: "el1ql8qy28058",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.79,100.38h-.48V101h-.24v-.63H68.73v-.17L70,98.64h.27l-1.21,1.53h1v-.55h.23v.55h.48Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "69.76px 99.82px"
    },
    id: "el8pmeofs4stv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.61,100.31c0,.4-.29.72-.86.72a1.19,1.19,0,0,1-.85-.31l.12-.19a1,1,0,0,0,.72.27c.41,0,.62-.19.62-.48s-.19-.5-.79-.5h-.51l.12-1.18h1.3v.21H71.4l-.08.76h.3C72.33,99.61,72.61,99.89,72.61,100.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "71.755px 99.8355px"
    },
    id: "elpgyg8ubegn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.69,100.3a.73.73,0,0,1-.8.73c-.63,0-1-.44-1-1.19s.44-1.22,1.09-1.22a1,1,0,0,1,.56.13l-.1.19a.83.83,0,0,0-.46-.11c-.51,0-.84.33-.84,1a1.28,1.28,0,0,0,0,.19.76.76,0,0,1,.73-.4A.71.71,0,0,1,74.69,100.3Zm-.24,0c0-.31-.23-.51-.59-.51a.52.52,0,1,0,0,1A.52.52,0,0,0,74.45,100.3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "73.79px 99.8257px"
    },
    id: "elpy5vxiq1dq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.59,100.79V101H74.93v-.18l1-1c.26-.27.31-.42.31-.59s-.19-.44-.55-.44a.81.81,0,0,0-.65.26L74.86,99a1.08,1.08,0,0,1,.84-.33c.48,0,.78.24.78.64a1,1,0,0,1-.38.74l-.81.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "75.725px 99.8341px"
    },
    id: "ele3jy6t0ynbj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.57,79.74H128v7.61h-1.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "127.285px 83.545px"
    },
    id: "elmo9z2nmcf7a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.79,79.74v7.61h-1.16l-4.19-5.15v5.15H130V79.74h1.16l4.19,5.15V79.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "133.395px 83.545px"
    },
    id: "elb0esr59vmm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.74,79.74l-3.31,7.61H141l-3.33-7.61h1.53l2.53,5.87,2.56-5.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "141.705px 83.545px"
    },
    id: "el3w2ojimzbx9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.93,83.54a4.1,4.1,0,1,1,4.1,3.92A3.9,3.9,0,0,1,145.93,83.54Zm6.77,0A2.68,2.68,0,1,0,150,86.22,2.59,2.59,0,0,0,152.7,83.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "150.026px 83.3626px"
    },
    id: "el9vn9o95bb6e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.63,79.74H157v7.61h-1.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "156.295px 83.545px"
    },
    id: "elyfeesraeav",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.55,83.54a4.12,4.12,0,0,1,7.09-2.64l-.92.86a2.66,2.66,0,0,0-2-.89,2.68,2.68,0,1,0,0,5.35,2.64,2.64,0,0,0,2-.91l.92.87a4.11,4.11,0,0,1-7.09-2.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.095px 83.5469px"
    },
    id: "elfsva30vgj64",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.7,86.16v1.19H167V79.74h5.55v1.19h-4.14v2h3.67v1.17h-3.67v2.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "169.85px 83.545px"
    },
    id: "elnxxqr687zj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.81,111.66a12,12,0,0,1-4.58,0,12,12,0,0,1,4.58,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "151.52px 111.66px"
    },
    id: "elblee8cgf2hm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.61,113.57a5.47,5.47,0,0,1,.56-2.07,5.21,5.21,0,0,1,1-1.92,10.57,10.57,0,0,1-1.53,4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "155.39px 111.58px"
    },
    id: "elhu3rhk858br",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.49,111.66c0,.12-.76.22-1.7.22s-1.7-.1-1.7-.22.76-.22,1.7-.22S160.49,111.54,160.49,111.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "158.79px 111.66px"
    },
    id: "elzwe6p0a488s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.89,113.1c-.12,0,.07-.84.42-1.78s.72-1.67.83-1.63-.07.84-.42,1.78S162,113.14,161.89,113.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.513px 111.395px"
    },
    id: "elg8za2jzpfvj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.46,111.66a13.46,13.46,0,0,1-3.4.22,13.4,13.4,0,0,1-3.4-.22,13.4,13.4,0,0,1,3.4-.22A13.46,13.46,0,0,1,170.46,111.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "167.06px 111.66px"
    },
    id: "el9wwigc5epkc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.97,
    y: 131.47,
    width: 130.57,
    height: 9.01,
    style: {
      fill: "#9B6EF3",
      transformOrigin: "110.255px 135.975px"
    },
    id: "el8n5o18gsko",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.27,147.64c0,.12-6.28.21-14,.21s-14-.09-14-.21,6.27-.22,14-.22S84.27,147.51,84.27,147.64Z",
    id: "eld7zrsvxvq5",
    className: "animable",
    style: {
      transformOrigin: "70.27px 147.635px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.12,147.93a42.93,42.93,0,0,1-6.11.22,43,43,0,0,1-6.12-.22,43,43,0,0,1,6.12-.22A42.93,42.93,0,0,1,130.12,147.93Z",
    id: "eldzuphw3zwd",
    className: "animable",
    style: {
      transformOrigin: "124.005px 147.93px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.32,147.19c0,.12-.6.22-1.34.22s-1.34-.1-1.34-.22.6-.22,1.34-.22S147.32,147.07,147.32,147.19Z",
    id: "eldyp6vueiu4g",
    className: "animable",
    style: {
      transformOrigin: "145.98px 147.19px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.73,147.49a34.86,34.86,0,0,1-5.44.21,34.76,34.76,0,0,1-5.44-.21,34,34,0,0,1,5.44-.22A34.08,34.08,0,0,1,170.73,147.49Z",
    id: "el85gb6yoar12",
    className: "animable",
    style: {
      transformOrigin: "165.29px 147.485px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.73,160.16c0,.12-9.51.22-21.24.22s-21.25-.1-21.25-.22,9.51-.22,21.25-.22S98.73,160,98.73,160.16Z",
    id: "elqx5i0mwwfn",
    className: "animable",
    style: {
      transformOrigin: "77.485px 160.16px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.88,160.31a28.63,28.63,0,0,1-5,.22,28.79,28.79,0,0,1-5-.22,28.79,28.79,0,0,1,5-.22A28.63,28.63,0,0,1,127.88,160.31Z",
    id: "elgcur4ulo7a7",
    className: "animable",
    style: {
      transformOrigin: "122.88px 160.31px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.92,160.16a8.66,8.66,0,0,1-3.88,0,8.66,8.66,0,0,1,3.88,0Z",
    id: "el58uf0y16zbg",
    className: "animable",
    style: {
      transformOrigin: "145.98px 160.16px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.24,159.86a31.38,31.38,0,0,1-5.22.22,31.38,31.38,0,0,1-5.22-.22,31.38,31.38,0,0,1,5.22-.22A31.38,31.38,0,0,1,169.24,159.86Z",
    id: "elpcgvcyzpu9",
    className: "animable",
    style: {
      transformOrigin: "164.02px 159.86px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.66,
    y: 185.59,
    width: 61.52,
    height: 8.02,
    style: {
      fill: "#9B6EF3",
      transformOrigin: "144.42px 189.6px"
    },
    id: "eltgme6wzn6z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.68,174.26a61.25,61.25,0,0,1-7.31.22,61.25,61.25,0,0,1-7.31-.22,62.67,62.67,0,0,1,7.31-.21A62.67,62.67,0,0,1,161.68,174.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "154.37px 174.265px"
    },
    id: "eltlh3s1dz2pg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.68,179.64a61.25,61.25,0,0,1-7.31.22,61.25,61.25,0,0,1-7.31-.22,61.25,61.25,0,0,1,7.31-.22A61.25,61.25,0,0,1,161.68,179.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "154.37px 179.64px"
    },
    id: "el596ornvqevv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.52,179.64a61.5,61.5,0,0,1-7.32.22,61.25,61.25,0,0,1-7.31-.22,61.25,61.25,0,0,1,7.31-.22A61.5,61.5,0,0,1,134.52,179.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "127.205px 179.64px"
    },
    id: "eloi7ct9mcvz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.52,174c0,.12-4.89.22-10.91.22s-10.91-.1-10.91-.22,4.88-.22,10.91-.22S134.52,173.87,134.52,174Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "123.61px 174px"
    },
    id: "elrgaovm1bzu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.68,190a61.25,61.25,0,0,1-7.31.22,61.25,61.25,0,0,1-7.31-.22,61.25,61.25,0,0,1,7.31-.22A61.25,61.25,0,0,1,161.68,190Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "154.37px 190px"
    },
    id: "eljljcvu2zybc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.32,190a61.25,61.25,0,0,1-7.31.22,61.25,61.25,0,0,1-7.31-.22,61.25,61.25,0,0,1,7.31-.22A61.25,61.25,0,0,1,135.32,190Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "128.01px 190px"
    },
    id: "elrzxffh65ri",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.25,
    y: 78.34,
    width: 4.22,
    height: 4.22,
    rx: 1.6,
    style: {
      fill: "#9B6EF3",
      transformOrigin: "51.36px 80.45px"
    },
    id: "eluxzh9943c0a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2,83.44v0a.25.25,0,0,0,.24.25h4.05v-4.2a.25.25,0,0,0-.25-.24h0a.24.24,0,0,0-.24.24v3.62l-3.56,0A.25.25,0,0,0,50.2,83.44Z",
    style: {
      fill: "#9B6EF3",
      transformOrigin: "52.3384px 81.47px"
    },
    id: "elk48v60hyn3e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.66,79.8c0,.12-5.42.22-12.09.22s-12.1-.1-12.1-.22,5.41-.22,12.1-.22S80.66,79.68,80.66,79.8Z",
    style: {
      fill: "#9B6EF3",
      transformOrigin: "68.565px 79.8px"
    },
    id: "eluhb19u7vohg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.44,82.12a45.87,45.87,0,0,1-6.32.22,46,46,0,0,1-6.33-.22,46,46,0,0,1,6.33-.22A45.87,45.87,0,0,1,69.44,82.12Z",
    style: {
      fill: "#9B6EF3",
      transformOrigin: "63.115px 82.12px"
    },
    id: "elplvz4k3e3p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.82,251.79c0-1.72-.08-75.83-.2-186.56l.2.2-146.13,0h0l.22-.22c0,69.16,0,133.39,0,186.56l-.18-.18,146.15.18L37.67,252h-.18v-.18c0-53.17,0-117.4,0-186.56V65h.24l146.13,0h.2v.2C183.9,176,183.82,250.07,183.82,251.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "110.775px 158.5px"
    },
    id: "elhq1cumu2rrb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.27,116.47c0,.12-7.82.22-17.47.22s-17.46-.1-17.46-.22,7.82-.22,17.46-.22S110.27,116.35,110.27,116.47Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "92.805px 116.47px"
    },
    id: "elys9q4ma8s1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.27,119.81c0,.12-7.82.22-17.47.22s-17.46-.1-17.46-.22,7.82-.22,17.46-.22S110.27,119.69,110.27,119.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "92.805px 119.81px"
    },
    id: "el5acoktk0grr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4,123.16a49,49,0,0,1-6.53.22,48.91,48.91,0,0,1-6.53-.22,48.91,48.91,0,0,1,6.53-.22A49,49,0,0,1,88.4,123.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "81.87px 123.16px"
    },
    id: "el3bv8d8zsyat",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.81,112.88c0,.12-14.7.22-32.83.22s-32.84-.1-32.84-.22,14.7-.22,32.84-.22S110.81,112.76,110.81,112.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "77.975px 112.88px"
    },
    id: "eldawiwtlciji",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.08,136c0,.12-6.56.22-14.65.22s-14.64-.1-14.64-.22,6.55-.22,14.64-.22S85.08,135.86,85.08,136Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "70.435px 136px"
    },
    id: "el94ofna6avgl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.64,136a68.87,68.87,0,0,1-7.75.22,68.87,68.87,0,0,1-7.75-.22,68.87,68.87,0,0,1,7.75-.22A68.87,68.87,0,0,1,130.64,136Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "122.89px 136px"
    },
    id: "el0bmmtitnumbv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.81,136a38.06,38.06,0,0,1-5.75.22,38.06,38.06,0,0,1-5.75-.22,38.06,38.06,0,0,1,5.75-.22A38.06,38.06,0,0,1,152.81,136Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "147.06px 136px"
    },
    id: "el7s0p7d1u8wq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,136a37.87,37.87,0,0,1-5.74.22,38,38,0,0,1-5.75-.22,38,38,0,0,1,5.75-.22A37.87,37.87,0,0,1,172,136Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "166.255px 136px"
    },
    id: "el4na7xtb8sst",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.67,200.33c0,.14-28.39.26-63.41.26s-63.42-.12-63.42-.26,28.39-.26,63.42-.26S173.67,200.19,173.67,200.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "110.255px 200.33px"
    },
    id: "el20l3x4rpbsu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.8,212.67c0,.14-12.62.26-28.17.26s-28.17-.12-28.17-.26,12.61-.26,28.17-.26S104.8,212.52,104.8,212.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "76.63px 212.67px"
    },
    id: "el6mot3kcv67g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.13,217.32c0,.14-9.77.26-21.83.26s-21.84-.12-21.84-.26,9.77-.26,21.84-.26S92.13,217.18,92.13,217.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "70.295px 217.32px"
    },
    id: "el3yqb2xlfqw9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.08,222c0,.14-8.2.26-18.31.26s-18.31-.12-18.31-.26,8.19-.26,18.31-.26S85.08,221.83,85.08,222Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "66.77px 222px"
    },
    id: "el8u0dnlwqbmf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,215.57a2.24,2.24,0,0,1-.35.1l-1,.25c-.91.22-2.25.51-4,.89-3.46.73-8.5,1.74-14.75,2.77-3.13.51-6.56,1-10.26,1.53-1.84.24-3.76.49-5.73.71l-3,.34c-.51.05-1,.13-1.55.15a3.09,3.09,0,0,1-1.64-.33,1.8,1.8,0,0,1-.94-1.48,1.77,1.77,0,0,1,1-1.45,25.33,25.33,0,0,1,3-1.43,31,31,0,0,1,13.46-2.3,13.69,13.69,0,0,1,3.57.56,5.88,5.88,0,0,1,3.1,2,4.46,4.46,0,0,1,.71,3.64,6.76,6.76,0,0,1-1.75,3.2A14,14,0,0,1,147,227a26.36,26.36,0,0,1-3,1.73,6.66,6.66,0,0,1-3.4.76,3.87,3.87,0,0,1-2.92-1.78,7.82,7.82,0,0,1-1.1-3.15,21.79,21.79,0,0,1-.2-3.21,23,23,0,0,1,3.2-11.44,8,8,0,0,1,1.73-2.2,2.52,2.52,0,0,1,2.68-.48,3.17,3.17,0,0,1,1.62,2.07,4.79,4.79,0,0,1-.14,2.5,15.11,15.11,0,0,1-.87,2.17c-.32.69-.65,1.35-1,2-.67,1.27-1.35,2.44-2,3.5a47.66,47.66,0,0,1-3.81,5.22c-1.14,1.36-2.1,2.36-2.76,3-.33.33-.6.57-.77.73l-.28.24.24-.28.73-.77c.64-.68,1.57-1.69,2.68-3.06a50.64,50.64,0,0,0,3.73-5.25c.66-1.07,1.32-2.23,2-3.5a29,29,0,0,0,1.8-4.1,4.5,4.5,0,0,0,.12-2.3,2.75,2.75,0,0,0-1.42-1.8,2.08,2.08,0,0,0-2.24.43,7.44,7.44,0,0,0-1.63,2.1,22.49,22.49,0,0,0-3.09,11.23,20.66,20.66,0,0,0,.21,3.13,7.31,7.31,0,0,0,1,3,3.36,3.36,0,0,0,2.56,1.55,6.28,6.28,0,0,0,3.13-.72,26.91,26.91,0,0,0,3-1.71,13.8,13.8,0,0,0,2.68-2.13,6.22,6.22,0,0,0,1.62-3,4,4,0,0,0-.62-3.23,5.39,5.39,0,0,0-2.83-1.83,13.85,13.85,0,0,0-3.44-.53,30.13,30.13,0,0,0-6.87.4,31.08,31.08,0,0,0-6.38,1.84,26.77,26.77,0,0,0-2.9,1.38,1.12,1.12,0,0,0-.08,2.11,5.32,5.32,0,0,0,2.9.13l3-.33,5.73-.69c3.69-.48,7.12-1,10.25-1.47,6.26-1,11.3-1.93,14.77-2.6l4-.79,1-.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "148.39px 218.267px"
    },
    id: "elwfnd8ph00y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.29,233.3a18.09,18.09,0,0,1-4.28.26,18.09,18.09,0,0,1-4.28-.26A18.09,18.09,0,0,1,128,233,18.09,18.09,0,0,1,132.29,233.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "128.01px 233.284px"
    },
    id: "ellkowc2xr3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.72 244.34 45.75 244.34 45.63 58.44 191.78 58.44 191.72 244.34",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "118.705px 151.39px"
    },
    id: "elbc1whz8yhqw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.57,
    y: 57.78,
    width: 146.15,
    height: 35.78,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "118.645px 75.67px"
    },
    id: "eljuozxxzw3u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.88,
    y: 88.15,
    width: 55.7,
    height: 9.01,
    style: {
      fill: "#9B6EF3",
      transformOrigin: "80.73px 92.655px"
    },
    id: "el7hs0ivor7ur",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.88,
    y: 133.03,
    width: 130.57,
    height: 12.94,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "118.165px 139.5px"
    },
    id: "elwfh9m1lc9d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.88,
    y: 145.96,
    width: 130.57,
    height: 12.94,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "118.165px 152.43px"
    },
    id: "elnnajgelszdi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.83,91.19h.25v2.36h-.25Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "58.955px 92.37px"
    },
    id: "el81dlhgltym",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.44,92.52v1H61.2v-1c0-.38-.19-.57-.53-.57a.58.58,0,0,0-.62.64v.93h-.24V91.77H60v.33a.74.74,0,0,1,.67-.34A.68.68,0,0,1,61.44,92.52Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "60.6278px 92.6366px"
    },
    id: "eld3splks82hk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.56,91.77l-.79,1.78h-.25l-.79-1.78H62l.67,1.52.67-1.52Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "62.645px 92.66px"
    },
    id: "els7vwa8ji2lr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.67,92.66a.91.91,0,0,1,1.81,0,.91.91,0,1,1-1.81,0Zm1.56,0a.66.66,0,1,0-.66.7A.65.65,0,0,0,65.23,92.66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "64.575px 92.7553px"
    },
    id: "elat3mj1znxjc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.91,91.21a.18.18,0,0,1,.36,0,.18.18,0,1,1-.36,0Zm.06.56h.24v1.78H66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "66.09px 92.29px"
    },
    id: "elayzmixa6jfj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7,92.66a.88.88,0,0,1,.92-.9.77.77,0,0,1,.69.35l-.18.12a.62.62,0,0,0-.51-.26.7.7,0,0,0,0,1.39.59.59,0,0,0,.51-.26l.18.12a.77.77,0,0,1-.69.35A.88.88,0,0,1,66.7,92.66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "67.5047px 92.665px"
    },
    id: "elctq26o0vjiu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3,92.74H68.81a.67.67,0,0,0,.71.62.7.7,0,0,0,.54-.24l.13.16a.85.85,0,0,1-.68.29.88.88,0,0,1-.94-.91.87.87,0,1,1,1.74,0S70.3,92.71,70.3,92.74Zm-1.49-.18h1.27a.64.64,0,0,0-1.27,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "69.4397px 92.6811px"
    },
    id: "el6v0ybcm0sx7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,92l-.09.72h.48v.18h-.5l-.08.64h-.18l.07-.64H73l-.08.64h-.18l.08-.64h-.49v-.18h.51l.09-.72h-.49v-.18H73l.08-.64h.18l-.08.64h.7l.08-.64h.18l-.08.64h.48V92Zm-.18,0h-.7l-.09.72h.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "73.435px 92.36px"
    },
    id: "elbehua1osiht",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.33,92.87c0,.4-.28.7-.86.7a1.22,1.22,0,0,1-.85-.3l.12-.19a1,1,0,0,0,.73.27c.4,0,.61-.18.61-.48s-.2-.47-.64-.47h-.16v-.18l.65-.82H74.72v-.21h1.52v.17l-.67.84C76.08,92.23,76.33,92.49,76.33,92.87Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "75.475px 92.3805px"
    },
    id: "elibw9ytnljs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.69,92.93h-.47v.62H78v-.62H76.64v-.17l1.25-1.57h.27L77,92.71h1v-.54h.24v.54h.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "77.675px 92.37px"
    },
    id: "el4yeyzehxv68",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.51,92.86c0,.4-.28.71-.86.71a1.2,1.2,0,0,1-.85-.3l.12-.19a1,1,0,0,0,.72.27c.41,0,.62-.2.62-.48s-.19-.5-.79-.5H79l.12-1.18h1.29v.21H79.3l-.08.76h.3C80.24,92.16,80.51,92.44,80.51,92.86Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "79.655px 92.3806px"
    },
    id: "elrhjkiqpk3vs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6,92.85a.74.74,0,0,1-.81.72c-.63,0-1-.43-1-1.18s.44-1.22,1.08-1.22a1.1,1.1,0,0,1,.56.12l-.1.2a.83.83,0,0,0-.46-.11c-.51,0-.84.33-.84,1,0,.05,0,.12,0,.19a.76.76,0,0,1,.73-.4A.71.71,0,0,1,82.6,92.85Zm-.24,0c0-.31-.23-.51-.6-.51a.55.55,0,0,0-.61.52c0,.26.22.51.63.51A.52.52,0,0,0,82.36,92.85Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "81.695px 92.3709px"
    },
    id: "elwbvyaid5jdk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.49,93.34v.21H82.83v-.17l1-1c.27-.27.32-.43.32-.59s-.2-.44-.56-.44a.81.81,0,0,0-.65.26l-.17-.15a1.1,1.1,0,0,1,.84-.33c.48,0,.79.24.79.64a1,1,0,0,1-.39.74l-.81.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "83.63px 92.3394px"
    },
    id: "el6lcrjyp576i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.47,72.29h1.41V79.9h-1.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "135.175px 76.095px"
    },
    id: "elg2nzzxq92qt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.7,72.29V79.9h-1.17l-4.19-5.15V79.9h-1.4V72.29h1.16l4.19,5.15V72.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "141.32px 76.095px"
    },
    id: "el2gie1fbpn9s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.64,72.29l-3.31,7.61h-1.39l-3.33-7.61h1.53l2.54,5.87,2.55-5.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "149.625px 76.095px"
    },
    id: "eltwilpv7sgic",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.83,76.09a4.1,4.1,0,1,1,4.1,3.91A3.89,3.89,0,0,1,153.83,76.09Zm6.77,0a2.67,2.67,0,1,0-2.67,2.68A2.59,2.59,0,0,0,160.6,76.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "157.926px 75.9028px"
    },
    id: "elsrtew1zwz7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.53,72.29h1.41V79.9h-1.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "164.235px 76.095px"
    },
    id: "el2b4nioi725j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.45,76.09a4.12,4.12,0,0,1,7.09-2.64l-.92.86a2.64,2.64,0,0,0-2-.89,2.68,2.68,0,1,0,0,5.35,2.63,2.63,0,0,0,2-.91l.92.87a4.12,4.12,0,0,1-7.09-2.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "169.995px 76.09px"
    },
    id: "elu5xbqinob1d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.6,78.71V79.9h-5.7V72.29h5.55v1.18h-4.14v2H180v1.16h-3.67v2.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "177.75px 76.095px"
    },
    id: "elqq0cw3ontrj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.71,104.21a6.21,6.21,0,0,1-2.29.22,6.13,6.13,0,0,1-2.28-.22,6.13,6.13,0,0,1,2.28-.22A6.21,6.21,0,0,1,161.71,104.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "159.425px 104.21px"
    },
    id: "eluo9qolhkny",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.51,106.11a5.51,5.51,0,0,1,.56-2.07,5.4,5.4,0,0,1,1-1.91,5.51,5.51,0,0,1-.56,2.07A5.28,5.28,0,0,1,162.51,106.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "163.29px 104.12px"
    },
    id: "elvr3xmbeg7ge",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.39,104.21c0,.12-.76.22-1.7.22s-1.7-.1-1.7-.22.76-.22,1.7-.22S168.39,104.09,168.39,104.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "166.69px 104.21px"
    },
    id: "elfb8lmnxv8ao",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.79,105.65a4.1,4.1,0,0,1,.42-1.78c.35-1,.72-1.68.83-1.63s-.07.84-.42,1.78S169.9,105.69,169.79,105.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "170.431px 103.944px"
    },
    id: "el36hua6w4aqm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.36,104.21a26.38,26.38,0,0,1-6.8,0,26.38,26.38,0,0,1,6.8,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "174.96px 104.21px"
    },
    id: "el3x1o8xboymc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.88,
    y: 124.02,
    width: 130.57,
    height: 9.01,
    style: {
      fill: "#9B6EF3",
      transformOrigin: "118.165px 128.525px"
    },
    id: "el3b9rd2c9dgn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.17,140.18c0,.12-6.28.22-14,.22s-14-.1-14-.22,6.27-.21,14-.21S92.17,140.06,92.17,140.18Z",
    id: "el2vyhksthar8",
    className: "animable",
    style: {
      transformOrigin: "78.17px 140.185px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,140.48a42.93,42.93,0,0,1-6.11.22,43,43,0,0,1-6.12-.22,43,43,0,0,1,6.12-.22A42.93,42.93,0,0,1,138,140.48Z",
    id: "eld5g9qco8k9r",
    className: "animable",
    style: {
      transformOrigin: "131.885px 140.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.22,139.74c0,.12-.6.22-1.34.22s-1.34-.1-1.34-.22.6-.22,1.34-.22S155.22,139.62,155.22,139.74Z",
    id: "elixccp88gud8",
    className: "animable",
    style: {
      transformOrigin: "153.88px 139.74px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.63,140a32.63,32.63,0,0,1-5.44.22,32.63,32.63,0,0,1-5.44-.22,34.76,34.76,0,0,1,5.44-.21A34.76,34.76,0,0,1,178.63,140Z",
    id: "elzf1me86eogi",
    className: "animable",
    style: {
      transformOrigin: "173.19px 140.006px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.63,152.71c0,.12-9.51.22-21.24.22s-21.25-.1-21.25-.22,9.51-.22,21.25-.22S106.63,152.59,106.63,152.71Z",
    id: "elgaczpmg6n7v",
    className: "animable",
    style: {
      transformOrigin: "85.385px 152.71px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.78,152.86a28.63,28.63,0,0,1-5,.22,28.79,28.79,0,0,1-5-.22,28.79,28.79,0,0,1,5-.22A28.63,28.63,0,0,1,135.78,152.86Z",
    id: "el83efacdlx6",
    className: "animable",
    style: {
      transformOrigin: "130.78px 152.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.82,152.71a8.66,8.66,0,0,1-3.88,0,8.66,8.66,0,0,1,3.88,0Z",
    id: "elswmz8ipq4vi",
    className: "animable",
    style: {
      transformOrigin: "153.88px 152.71px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.14,152.41a31.38,31.38,0,0,1-5.22.22,31.38,31.38,0,0,1-5.22-.22,31.38,31.38,0,0,1,5.22-.22A31.38,31.38,0,0,1,177.14,152.41Z",
    id: "elcg2y3wz0ivm",
    className: "animable",
    style: {
      transformOrigin: "171.92px 152.41px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.56,
    y: 178.14,
    width: 61.52,
    height: 8.02,
    style: {
      fill: "#9B6EF3",
      transformOrigin: "152.32px 182.15px"
    },
    id: "elz75qxhiu1ro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.59,166.81a61.5,61.5,0,0,1-7.32.22,61.39,61.39,0,0,1-7.31-.22,61.39,61.39,0,0,1,7.31-.22A61.5,61.5,0,0,1,169.59,166.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.275px 166.81px"
    },
    id: "el85hnbo82ltv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.59,172.19a61.5,61.5,0,0,1-7.32.22,61.39,61.39,0,0,1-7.31-.22,61.39,61.39,0,0,1,7.31-.22A61.5,61.5,0,0,1,169.59,172.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.275px 172.19px"
    },
    id: "elad5rrltttfm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.42,172.19a61.39,61.39,0,0,1-7.31.22,61.5,61.5,0,0,1-7.32-.22,61.5,61.5,0,0,1,7.32-.22A61.39,61.39,0,0,1,142.42,172.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "135.105px 172.19px"
    },
    id: "el5bls53999u4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.42,166.54c0,.12-4.89.22-10.91.22s-10.91-.1-10.91-.22,4.89-.22,10.91-.22S142.42,166.42,142.42,166.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "131.51px 166.54px"
    },
    id: "elf3xfvqyauj4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.59,182.55a61.5,61.5,0,0,1-7.32.22,61.39,61.39,0,0,1-7.31-.22,61.39,61.39,0,0,1,7.31-.22A61.5,61.5,0,0,1,169.59,182.55Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "162.275px 182.55px"
    },
    id: "elv55gc1i5069",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.22,182.55a61.25,61.25,0,0,1-7.31.22,61.25,61.25,0,0,1-7.31-.22,61.25,61.25,0,0,1,7.31-.22A61.25,61.25,0,0,1,143.22,182.55Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "135.91px 182.55px"
    },
    id: "elrpai2516l1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.15,
    y: 70.89,
    width: 4.22,
    height: 4.22,
    rx: 1.6,
    style: {
      fill: "#9B6EF3",
      transformOrigin: "59.26px 73px"
    },
    id: "elbrg07vrw7is",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1,76V76a.25.25,0,0,0,.24.25h4v-4.2a.24.24,0,0,0-.24-.24h0a.25.25,0,0,0-.25.24v3.62l-3.56,0A.25.25,0,0,0,58.1,76Z",
    style: {
      fill: "#9B6EF3",
      transformOrigin: "60.2127px 74.03px"
    },
    id: "elmemuhj7r8fm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.56,72.35c0,.12-5.41.22-12.09.22s-12.1-.1-12.1-.22,5.42-.22,12.1-.22S88.56,72.23,88.56,72.35Z",
    style: {
      fill: "#9B6EF3",
      transformOrigin: "76.465px 72.35px"
    },
    id: "elvglw6i13q8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.35,74.67a46.08,46.08,0,0,1-6.33.22,46,46,0,0,1-6.33-.22A46,46,0,0,1,71,74.45,46.08,46.08,0,0,1,77.35,74.67Z",
    style: {
      fill: "#9B6EF3",
      transformOrigin: "71.02px 74.6698px"
    },
    id: "elvnkev3r8san",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.72,244.34c0-1.72-.08-75.83-.19-186.56l.19.19L45.59,58h0l.22-.22c0,69.16,0,133.39,0,186.56l-.18-.18,146.15.18-146.15.18h-.18v-.18c0-53.17,0-117.4,0-186.56v-.22h.24l146.13,0h.2v.2C191.8,168.51,191.72,242.62,191.72,244.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "118.735px 151.04px"
    },
    id: "elb4vkgmktyth",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.17,109c0,.12-7.82.22-17.46.22s-17.47-.1-17.47-.22,7.82-.22,17.47-.22S118.17,108.9,118.17,109Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "100.705px 109px"
    },
    id: "el3xezurn5ys6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.17,112.36c0,.12-7.82.22-17.46.22s-17.47-.1-17.47-.22,7.82-.22,17.47-.22S118.17,112.24,118.17,112.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "100.705px 112.36px"
    },
    id: "elr9pgwmhxm8c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3,115.71a50,50,0,0,1-6.53.21,50.16,50.16,0,0,1-6.53-.21,47.08,47.08,0,0,1,6.53-.22A47,47,0,0,1,96.3,115.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "89.77px 115.704px"
    },
    id: "elqe7s8frl2wi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.71,105.43c0,.12-14.7.22-32.83.22s-32.83-.1-32.83-.22,14.69-.22,32.83-.22S118.71,105.31,118.71,105.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "85.88px 105.43px"
    },
    id: "elsce6h92l45",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,128.52c0,.13-6.56.22-14.64.22s-14.65-.09-14.65-.22,6.56-.21,14.65-.21S93,128.4,93,128.52Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "78.355px 128.525px"
    },
    id: "elzhw8g3jyg8j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.54,128.52a66.14,66.14,0,0,1-7.75.22,66.14,66.14,0,0,1-7.75-.22,70.47,70.47,0,0,1,7.75-.21A70.47,70.47,0,0,1,138.54,128.52Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "130.79px 128.526px"
    },
    id: "el0odko5q0aly",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.71,128.52a36.45,36.45,0,0,1-5.75.22,36.55,36.55,0,0,1-5.75-.22,38.94,38.94,0,0,1,5.75-.21A38.82,38.82,0,0,1,160.71,128.52Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "154.96px 128.526px"
    },
    id: "elusfcn85hsf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.88,128.52a36.55,36.55,0,0,1-5.75.22,36.55,36.55,0,0,1-5.75-.22,38.94,38.94,0,0,1,5.75-.21A38.94,38.94,0,0,1,179.88,128.52Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "174.13px 128.526px"
    },
    id: "eleyfuztdddt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.58,192.88c0,.14-28.4.26-63.42.26s-63.41-.12-63.41-.26,28.38-.26,63.41-.26S181.58,192.73,181.58,192.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "118.165px 192.88px"
    },
    id: "el8endwey8dhr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.7,205.22c0,.14-12.61.26-28.17.26s-28.17-.12-28.17-.26S69,205,84.53,205,112.7,205.07,112.7,205.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "84.53px 205.24px"
    },
    id: "elkfuvkotf2ib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,209.87c0,.14-9.78.26-21.84.26s-21.84-.12-21.84-.26,9.77-.26,21.84-.26S100,209.72,100,209.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "78.16px 209.87px"
    },
    id: "elrtro00q69uo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,214.52c0,.14-8.2.26-18.31.26s-18.31-.12-18.31-.26,8.19-.26,18.31-.26S93,214.38,93,214.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "74.69px 214.52px"
    },
    id: "elaxgh2ttayo8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.91,208.12l-.35.1-1,.25c-.91.21-2.25.51-4,.88-3.47.74-8.5,1.74-14.76,2.78-3.13.51-6.56,1-10.25,1.52q-2.78.38-5.74.72l-3,.34c-.51,0-1,.13-1.55.15a3.12,3.12,0,0,1-1.64-.33,1.59,1.59,0,0,1,.06-2.93,25.33,25.33,0,0,1,3-1.43,30.84,30.84,0,0,1,6.48-1.88,31.19,31.19,0,0,1,7-.42,14.11,14.11,0,0,1,3.56.55,5.9,5.9,0,0,1,3.11,2,4.48,4.48,0,0,1,.7,3.63,6.73,6.73,0,0,1-1.74,3.21,14.33,14.33,0,0,1-2.79,2.22,29.09,29.09,0,0,1-3,1.73,6.87,6.87,0,0,1-3.4.76,3.87,3.87,0,0,1-2.92-1.78,7.66,7.66,0,0,1-1.09-3.15,21.81,21.81,0,0,1-.21-3.21,23,23,0,0,1,3.2-11.44,8,8,0,0,1,1.73-2.2,2.52,2.52,0,0,1,2.68-.48,3.14,3.14,0,0,1,1.62,2.07,4.9,4.9,0,0,1-.13,2.5,15.12,15.12,0,0,1-.88,2.17c-.32.69-.65,1.35-1,2-.67,1.27-1.34,2.44-2,3.5a48.94,48.94,0,0,1-3.82,5.22c-1.14,1.36-2.1,2.36-2.76,3-.33.34-.59.57-.77.74a1.63,1.63,0,0,1-.27.23,1.63,1.63,0,0,1,.23-.27c.19-.19.43-.45.73-.77.64-.68,1.57-1.69,2.68-3.07a49.33,49.33,0,0,0,3.73-5.24c.66-1.07,1.33-2.24,2-3.5a27.87,27.87,0,0,0,1.8-4.1,4.5,4.5,0,0,0,.12-2.3,2.76,2.76,0,0,0-1.42-1.81,2.1,2.1,0,0,0-2.24.44,7.82,7.82,0,0,0-1.63,2.1,22.67,22.67,0,0,0-3.09,11.23A22.14,22.14,0,0,0,145,217a7.22,7.22,0,0,0,1,2.94,3.37,3.37,0,0,0,2.56,1.56,6.28,6.28,0,0,0,3.13-.72,26.91,26.91,0,0,0,3-1.71,13.86,13.86,0,0,0,2.69-2.13,6.29,6.29,0,0,0,1.61-3,4,4,0,0,0-.61-3.23,5.42,5.42,0,0,0-2.84-1.83,14.27,14.27,0,0,0-3.44-.54,30.63,30.63,0,0,0-13.25,2.25,27.69,27.69,0,0,0-2.9,1.38,1.32,1.32,0,0,0-.77,1,1.28,1.28,0,0,0,.69,1.06,5.14,5.14,0,0,0,2.9.13l3-.32,5.73-.69c3.69-.48,7.12-1,10.25-1.47,6.26-1,11.3-1.93,14.78-2.6l4-.79,1-.2A1.25,1.25,0,0,1,177.91,208.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "156.294px 210.746px"
    },
    id: "elzoz7j7iizp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.19,225.85a18.09,18.09,0,0,1-4.28.26,18.09,18.09,0,0,1-4.28-.26,17.48,17.48,0,0,1,4.28-.26A17.48,17.48,0,0,1,140.19,225.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "135.91px 225.848px"
    },
    id: "elny94sud9c5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.91 236.51 52.94 236.51 52.83 50.61 198.97 50.61 198.91 236.51",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "125.9px 143.56px"
    },
    id: "elw2njqbdm7e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.76,
    y: 49.95,
    width: 146.15,
    height: 35.78,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "125.835px 67.84px"
    },
    id: "el7kz9x334k9p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.07,
    y: 80.31,
    width: 55.7,
    height: 9.01,
    style: {
      fill: "#9B6EF3",
      transformOrigin: "87.92px 84.815px"
    },
    id: "el7bo3sjof1u3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.07,
    y: 125.2,
    width: 130.57,
    height: 12.94,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "125.355px 131.67px"
    },
    id: "el7b7xsnm0kna",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.07,
    y: 138.13,
    width: 130.57,
    height: 12.94,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "125.355px 144.6px"
    },
    id: "elbydw6723nff",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,83.35h.25v2.37H66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "66.125px 84.535px"
    },
    id: "el7rm1s4oud5w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.63,84.69v1h-.24v-1a.49.49,0,0,0-.53-.56.58.58,0,0,0-.62.64v.93H67V83.94h.23v.33a.72.72,0,0,1,.67-.34A.68.68,0,0,1,68.63,84.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "67.8175px 84.8139px"
    },
    id: "el9bayy6is95",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.75,83.94,70,85.72h-.25l-.79-1.78h.25l.67,1.52.67-1.52Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "69.855px 84.83px"
    },
    id: "elj7grqeg22dh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.86,84.83a.91.91,0,0,1,1.81,0,.91.91,0,1,1-1.81,0Zm1.56,0a.66.66,0,1,0-.66.7A.65.65,0,0,0,72.42,84.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "71.765px 84.9253px"
    },
    id: "elmgpw6zy0kx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1,83.38a.18.18,0,0,1,.36,0,.18.18,0,0,1-.36,0Zm.06.56h.24v1.78h-.24Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "73.28px 84.46px"
    },
    id: "el5yrt6qay4d8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.89,84.83a.87.87,0,0,1,.92-.9.77.77,0,0,1,.69.35l-.18.12a.59.59,0,0,0-.51-.26.7.7,0,0,0,0,1.39.59.59,0,0,0,.51-.26l.18.12a.77.77,0,0,1-.69.35A.88.88,0,0,1,73.89,84.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "74.6947px 84.8349px"
    },
    id: "el68cnv06c1kc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.49,84.91H76a.67.67,0,0,0,.7.62.71.71,0,0,0,.55-.24l.13.16a.85.85,0,0,1-.68.29.88.88,0,0,1-.94-.91.87.87,0,1,1,1.74,0S77.49,84.88,77.49,84.91ZM76,84.73h1.27a.64.64,0,0,0-1.27,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "76.6297px 84.8511px"
    },
    id: "elib18fk9mvxq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.18,84.18l-.09.71h.48v.19h-.5l-.08.64h-.18l.07-.64h-.69l-.08.64h-.18l.07-.64h-.48v-.19H80l.09-.71h-.49V84h.51l.08-.65h.18l-.08.65H81l.08-.65h.18L81.2,84h.48v.18Zm-.18,0h-.7l-.09.71h.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "80.6px 84.535px"
    },
    id: "el0xojyrvr0tl9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.52,85c0,.4-.28.7-.86.7a1.25,1.25,0,0,1-.85-.3l.12-.19a1.08,1.08,0,0,0,.73.27c.4,0,.61-.18.61-.48s-.2-.47-.64-.47h-.16v-.18l.65-.82H81.91v-.22h1.52v.18l-.67.84C83.27,84.4,83.52,84.66,83.52,85Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "82.665px 84.5053px"
    },
    id: "el0488a8pq1wmt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.88,85.1h-.47v.62h-.25V85.1H83.83v-.18l1.25-1.57h.27l-1.21,1.53h1v-.54h.24v.54h.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "84.855px 84.535px"
    },
    id: "eldeliannjjn4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7,85c0,.4-.28.71-.86.71a1.25,1.25,0,0,1-.85-.3l.12-.19a1,1,0,0,0,.72.27c.41,0,.62-.2.62-.48s-.19-.5-.79-.5h-.51l.13-1.19h1.29v.22H86.49l-.08.76h.3C87.43,84.33,87.7,84.61,87.7,85Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "86.845px 84.5153px"
    },
    id: "elru9icwuowx8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.79,85a.74.74,0,0,1-.81.72c-.63,0-1-.43-1-1.18s.44-1.23,1.08-1.23a1.1,1.1,0,0,1,.56.13l-.1.2a.83.83,0,0,0-.46-.11c-.51,0-.84.33-.84,1,0,0,0,.12,0,.19A.77.77,0,0,1,89,84.3.72.72,0,0,1,89.79,85Zm-.24,0c0-.31-.23-.51-.6-.51a.55.55,0,0,0-.61.52c0,.26.22.51.63.51A.52.52,0,0,0,89.55,85Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "88.885px 84.5163px"
    },
    id: "ellj4su570d3r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.68,85.51v.21H90v-.17l1-1c.26-.27.32-.43.32-.59s-.2-.44-.56-.44a.81.81,0,0,0-.65.26L90,83.67a1.09,1.09,0,0,1,.84-.34c.48,0,.79.25.79.64a1,1,0,0,1-.39.74l-.81.8Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "90.84px 84.5245px"
    },
    id: "el0hozc6ksvm9q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.66,64.46h1.41v7.6h-1.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "142.365px 68.26px"
    },
    id: "el3mis38rqcz8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.88,64.46v7.6h-1.16l-4.19-5.15v5.15h-1.4v-7.6h1.16l4.19,5.15V64.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "148.505px 68.26px"
    },
    id: "el8325ofdk29s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.83,64.46l-3.31,7.6h-1.39l-3.33-7.6h1.53l2.54,5.87,2.55-5.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "156.815px 68.26px"
    },
    id: "elof9gcpymprr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,68.26a4.1,4.1,0,1,1,4.1,3.91A3.89,3.89,0,0,1,161,68.26Zm6.77,0a2.68,2.68,0,1,0-2.67,2.67A2.59,2.59,0,0,0,167.79,68.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "165.096px 68.0728px"
    },
    id: "elvuzb9lz4de",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.72,64.46h1.41v7.6h-1.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "171.425px 68.26px"
    },
    id: "el36m077x1m92",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.64,68.26a4.12,4.12,0,0,1,7.09-2.64l-.92.86a2.64,2.64,0,0,0-2-.89,2.67,2.67,0,1,0,2,4.44l.92.87a4.12,4.12,0,0,1-7.09-2.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "177.185px 68.26px"
    },
    id: "elb8ayj2za9l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.79,70.88v1.18h-5.7v-7.6h5.55v1.18H183.5v2h3.67v1.16H183.5v2.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "184.94px 68.26px"
    },
    id: "el5exynjzel2p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.9,96.38a6.34,6.34,0,0,1-2.29.21,6.26,6.26,0,0,1-2.28-.21,5.9,5.9,0,0,1,2.28-.22A6,6,0,0,1,168.9,96.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "166.615px 96.3738px"
    },
    id: "el92l10cxueb5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.7,98.28a5.51,5.51,0,0,1,.56-2.07,5.4,5.4,0,0,1,1-1.91,5.51,5.51,0,0,1-.56,2.07A5.28,5.28,0,0,1,169.7,98.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "170.48px 96.29px"
    },
    id: "elp8rd4kynu8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.58,96.38c0,.12-.76.21-1.7.21s-1.7-.09-1.7-.21.76-.22,1.7-.22S175.58,96.25,175.58,96.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "173.88px 96.375px"
    },
    id: "elkelw2o304xk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,97.82A4.1,4.1,0,0,1,177.4,96c.35-1,.72-1.68.83-1.64s-.07.84-.42,1.79S177.09,97.86,177,97.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "177.631px 96.0899px"
    },
    id: "elz1t0e07n80m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.55,96.38a27.63,27.63,0,0,1-6.8,0,26.38,26.38,0,0,1,6.8,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "182.15px 96.375px"
    },
    id: "eld6x38tgue5o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.07,
    y: 116.19,
    width: 130.57,
    height: 9.01,
    style: {
      fill: "#9B6EF3",
      transformOrigin: "125.355px 120.695px"
    },
    id: "elypadzgaq09",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.36,132.35c0,.12-6.28.22-14,.22s-14-.1-14-.22,6.27-.22,14-.22S99.36,132.23,99.36,132.35Z",
    id: "eljlegj41hrpi",
    className: "animable",
    style: {
      transformOrigin: "85.36px 132.35px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.21,132.65a42.93,42.93,0,0,1-6.11.22,43,43,0,0,1-6.12-.22,43,43,0,0,1,6.12-.22A42.93,42.93,0,0,1,145.21,132.65Z",
    id: "elh4w1j1oqvh8",
    className: "animable",
    style: {
      transformOrigin: "139.095px 132.65px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.41,131.91c0,.12-.6.21-1.34.21s-1.34-.09-1.34-.21.6-.22,1.34-.22S162.41,131.78,162.41,131.91Z",
    id: "elje28h1t4qt",
    className: "animable",
    style: {
      transformOrigin: "161.07px 131.905px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.82,132.2a34.08,34.08,0,0,1-5.44.22,34,34,0,0,1-5.44-.22,34,34,0,0,1,5.44-.22A34.08,34.08,0,0,1,185.82,132.2Z",
    id: "elzbiotoasdcm",
    className: "animable",
    style: {
      transformOrigin: "180.38px 132.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.82,144.88c0,.12-9.51.22-21.24.22s-21.25-.1-21.25-.22,9.51-.22,21.25-.22S113.82,144.76,113.82,144.88Z",
    id: "eljlkiqvr6ie",
    className: "animable",
    style: {
      transformOrigin: "92.575px 144.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,145a29.28,29.28,0,0,1-5,.21,29.45,29.45,0,0,1-5-.21,28.79,28.79,0,0,1,5-.22A28.63,28.63,0,0,1,143,145Z",
    id: "elgjmtuyfl4xn",
    className: "animable",
    style: {
      transformOrigin: "138px 144.995px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,144.88a8.66,8.66,0,0,1-3.88,0,8.66,8.66,0,0,1,3.88,0Z",
    id: "elup1uba2wp3m",
    className: "animable",
    style: {
      transformOrigin: "161.06px 144.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.33,144.58a31.38,31.38,0,0,1-5.22.22,31.38,31.38,0,0,1-5.22-.22,31.38,31.38,0,0,1,5.22-.22A31.38,31.38,0,0,1,184.33,144.58Z",
    id: "eleogo847m89c",
    className: "animable",
    style: {
      transformOrigin: "179.11px 144.58px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.75,
    y: 170.3,
    width: 61.52,
    height: 8.02,
    style: {
      fill: "#9B6EF3",
      transformOrigin: "159.51px 174.31px"
    },
    id: "eluynl0bmeibk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.78,159a61.5,61.5,0,0,1-7.32.22,61.25,61.25,0,0,1-7.31-.22,61.25,61.25,0,0,1,7.31-.22A61.5,61.5,0,0,1,176.78,159Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "169.465px 159px"
    },
    id: "el89zavm17cm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.78,164.36a61.5,61.5,0,0,1-7.32.22,61.25,61.25,0,0,1-7.31-.22,61.25,61.25,0,0,1,7.31-.22A61.5,61.5,0,0,1,176.78,164.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "169.465px 164.36px"
    },
    id: "elebgskoi4gos",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.61,164.36a61.5,61.5,0,0,1-7.32.22,61.39,61.39,0,0,1-7.31-.22,61.39,61.39,0,0,1,7.31-.22A61.5,61.5,0,0,1,149.61,164.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "142.295px 164.36px"
    },
    id: "el8sss5ft1sio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.61,158.71c0,.12-4.89.22-10.91.22s-10.91-.1-10.91-.22,4.88-.22,10.91-.22S149.61,158.59,149.61,158.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "138.7px 158.71px"
    },
    id: "elhuqpjki6tjr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.78,174.72a61.5,61.5,0,0,1-7.32.22,61.25,61.25,0,0,1-7.31-.22,61.25,61.25,0,0,1,7.31-.22A61.5,61.5,0,0,1,176.78,174.72Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "169.465px 174.72px"
    },
    id: "elrqfexnspgbr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.41,174.72a61.25,61.25,0,0,1-7.31.22,61.25,61.25,0,0,1-7.31-.22,61.25,61.25,0,0,1,7.31-.22A61.25,61.25,0,0,1,150.41,174.72Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "143.1px 174.72px"
    },
    id: "elgm5kat9pm6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.34,
    y: 63.06,
    width: 4.22,
    height: 4.22,
    rx: 1.6,
    style: {
      fill: "#9B6EF3",
      transformOrigin: "66.45px 65.17px"
    },
    id: "elp84p1gdw73n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.29,68.16v0a.24.24,0,0,0,.24.24h4V64.26a.25.25,0,0,0-.24-.25h0a.25.25,0,0,0-.25.25v3.62l-3.56,0A.25.25,0,0,0,65.29,68.16Z",
    style: {
      fill: "#9B6EF3",
      transformOrigin: "67.4086px 66.205px"
    },
    id: "elvunpc17lboi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.75,64.52c0,.12-5.41.21-12.09.21s-12.1-.09-12.1-.21,5.42-.22,12.1-.22S95.75,64.39,95.75,64.52Z",
    style: {
      fill: "#9B6EF3",
      transformOrigin: "83.655px 64.515px"
    },
    id: "el5jz4lp63424",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.54,66.84a46.08,46.08,0,0,1-6.33.22,46,46,0,0,1-6.33-.22,46,46,0,0,1,6.33-.22A46.08,46.08,0,0,1,84.54,66.84Z",
    style: {
      fill: "#9B6EF3",
      transformOrigin: "78.21px 66.84px"
    },
    id: "eloydg9ozdq9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.91,236.51c0-1.72-.08-75.83-.19-186.56l.19.19-146.13,0h0L53,50c0,69.16,0,133.39,0,186.56l-.18-.18,146.15.18-146.15.18h-.18v-.18c0-53.17,0-117.4,0-186.56v-.22h.24l146.13,0h.2V50C199,160.68,198.91,234.79,198.91,236.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "125.925px 143.26px"
    },
    id: "els2td79bqyyl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.36,101.19c0,.12-7.82.21-17.46.21s-17.47-.09-17.47-.21,7.82-.22,17.47-.22S125.36,101.07,125.36,101.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "107.895px 101.185px"
    },
    id: "elqbg79x4x8u9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.36,104.53c0,.12-7.82.22-17.46.22s-17.47-.1-17.47-.22,7.82-.22,17.47-.22S125.36,104.41,125.36,104.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "107.895px 104.53px"
    },
    id: "eln6nf01o01wl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.49,107.87a48.91,48.91,0,0,1-6.53.22,48.91,48.91,0,0,1-6.53-.22,50,50,0,0,1,6.53-.21A50,50,0,0,1,103.49,107.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "96.96px 107.875px"
    },
    id: "el94cy1ork7v6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.9,97.59c0,.13-14.7.22-32.83.22s-32.83-.09-32.83-.22,14.69-.21,32.83-.21S125.9,97.47,125.9,97.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "93.07px 97.595px"
    },
    id: "el0izvcjutl7t5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.17,120.69c0,.12-6.56.22-14.64.22s-14.65-.1-14.65-.22,6.56-.22,14.65-.22S100.17,120.57,100.17,120.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "85.525px 120.69px"
    },
    id: "elmxvvlfq2fxr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.73,120.69a68.87,68.87,0,0,1-7.75.22,68.87,68.87,0,0,1-7.75-.22,68.87,68.87,0,0,1,7.75-.22A68.87,68.87,0,0,1,145.73,120.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "137.98px 120.69px"
    },
    id: "el4a9788cvsrj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.9,120.69a38.06,38.06,0,0,1-5.75.22,38.06,38.06,0,0,1-5.75-.22,38.06,38.06,0,0,1,5.75-.22A38.06,38.06,0,0,1,167.9,120.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "162.15px 120.69px"
    },
    id: "el9yldyoz71n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.07,120.69a38.06,38.06,0,0,1-5.75.22,38.06,38.06,0,0,1-5.75-.22,38.06,38.06,0,0,1,5.75-.22A38.06,38.06,0,0,1,187.07,120.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "181.32px 120.69px"
    },
    id: "elecvtzrf5yje",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.76,185.05c0,.14-28.39.26-63.41.26s-63.41-.12-63.41-.26,28.38-.26,63.41-.26S188.76,184.9,188.76,185.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "125.35px 185.05px"
    },
    id: "elrfzjy42u8u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.89,197.38c0,.15-12.61.26-28.17.26s-28.17-.11-28.17-.26,12.61-.26,28.17-.26S119.89,197.24,119.89,197.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "91.72px 197.38px"
    },
    id: "eldt8wzvj7and",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.23,202c0,.14-9.78.26-21.84.26s-21.84-.12-21.84-.26,9.77-.26,21.84-.26S107.23,201.89,107.23,202Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "85.39px 202px"
    },
    id: "elpumt5lmfzgb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.17,206.69c0,.14-8.2.26-18.31.26s-18.31-.12-18.31-.26,8.19-.26,18.31-.26S100.17,206.54,100.17,206.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "81.86px 206.69px"
    },
    id: "el1i1zyevd0cz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.1,200.28a1.63,1.63,0,0,1-.35.11l-1,.25c-.91.21-2.25.51-4,.88-3.47.74-8.5,1.74-14.76,2.77-3.13.52-6.56,1-10.25,1.53q-2.78.38-5.74.72l-3,.34c-.51.05-1,.12-1.55.14a3,3,0,0,1-1.64-.32,1.8,1.8,0,0,1-.94-1.48,1.82,1.82,0,0,1,1-1.46,27,27,0,0,1,3-1.42,30.84,30.84,0,0,1,6.48-1.88,30.06,30.06,0,0,1,7-.42,14.11,14.11,0,0,1,3.56.55,5.94,5.94,0,0,1,3.11,2,4.51,4.51,0,0,1,.7,3.64,6.73,6.73,0,0,1-1.74,3.21,14.58,14.58,0,0,1-2.79,2.21,27.46,27.46,0,0,1-3,1.74,6.87,6.87,0,0,1-3.4.76,3.87,3.87,0,0,1-2.92-1.78,7.71,7.71,0,0,1-1.09-3.15,21.81,21.81,0,0,1-.21-3.21,23,23,0,0,1,3.2-11.44,8.22,8.22,0,0,1,1.73-2.21,2.54,2.54,0,0,1,2.68-.47,3.12,3.12,0,0,1,1.62,2.07,4.9,4.9,0,0,1-.13,2.5,15.12,15.12,0,0,1-.88,2.17c-.32.69-.65,1.34-1,2-.67,1.27-1.34,2.44-2,3.5a50,50,0,0,1-3.82,5.22c-1.14,1.36-2.1,2.36-2.76,3-.33.33-.59.57-.77.74a1.63,1.63,0,0,1-.27.23,1.63,1.63,0,0,1,.23-.27c.19-.19.43-.45.73-.77.64-.68,1.57-1.69,2.68-3.07a49.33,49.33,0,0,0,3.73-5.24c.66-1.07,1.33-2.24,2-3.5a27.87,27.87,0,0,0,1.8-4.1,4.5,4.5,0,0,0,.12-2.3,2.76,2.76,0,0,0-1.42-1.81,2.1,2.1,0,0,0-2.24.44,7.82,7.82,0,0,0-1.63,2.1A22.66,22.66,0,0,0,152,206a22.18,22.18,0,0,0,.21,3.14,7.27,7.27,0,0,0,1,2.94,3.4,3.4,0,0,0,2.56,1.56,6.38,6.38,0,0,0,3.13-.72,26.91,26.91,0,0,0,3-1.71,14.58,14.58,0,0,0,2.69-2.13,6.34,6.34,0,0,0,1.61-3,4,4,0,0,0-.61-3.23,5.42,5.42,0,0,0-2.84-1.83,14.27,14.27,0,0,0-3.44-.54A30.63,30.63,0,0,0,146,202.8a27.69,27.69,0,0,0-2.9,1.38,1.32,1.32,0,0,0-.77,1,1.28,1.28,0,0,0,.69,1.06,5.14,5.14,0,0,0,2.9.13l3-.32,5.73-.7c3.69-.47,7.12-1,10.25-1.46,6.26-1,11.3-1.93,14.77-2.61l4-.79,1-.19A3.36,3.36,0,0,1,185.1,200.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "163.485px 202.926px"
    },
    id: "el8gupb9si6vr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.83,229.9c0,.14-28.67.26-64,.26s-64-.12-64-.26,28.67-.26,64-.26S192.83,229.75,192.83,229.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "128.83px 229.9px"
    },
    id: "el8j40bkhive",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.38,218a18.09,18.09,0,0,1-4.28.26,18.09,18.09,0,0,1-4.28-.26,17.48,17.48,0,0,1,4.28-.26A17.48,17.48,0,0,1,147.38,218Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "143.1px 217.998px"
    },
    id: "el8bykb1utb",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2",
    className: "animable",
    style: {
      transformOrigin: "418.275px 206.416px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.64,249.48l10.17-17.92a48.06,48.06,0,1,1,11.5,12.79l0,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "418.211px 206.34px"
    },
    id: "elci22jasuyr4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.64,249.48l21.66-5.23-.07.2,0,0-.6-.78.78.6a49.4,49.4,0,0,0,9.83,5.86,48.12,48.12,0,0,0,13.07,3.68,42.41,42.41,0,0,0,7.53.35c1.3-.08,2.62-.11,3.95-.23l4-.61a48.08,48.08,0,0,0,29.64-19.11,47.36,47.36,0,0,0,8-18.34,48.45,48.45,0,0,0-.58-21.1,46.86,46.86,0,0,0-10.16-19.49l-1.94-2.14c-.64-.71-1.4-1.3-2.09-2s-1.37-1.33-2.14-1.88-1.52-1.13-2.28-1.7a21.89,21.89,0,0,0-2.36-1.56l-2.4-1.46L440,163.34a21.34,21.34,0,0,0-2.54-1.13,48.3,48.3,0,0,0-21.26-3.28,46.83,46.83,0,0,0-19.52,5.74,48.21,48.21,0,0,0-22.6,27.7,51.42,51.42,0,0,0-2.12,15.46,47.77,47.77,0,0,0,2.28,13.38,48.39,48.39,0,0,0,4.73,10.28l0,.07,0,.06-10.28,17.86,10.06-18v.12a48.81,48.81,0,0,1-4.8-10.32,47.46,47.46,0,0,1-2.35-13.46,51.9,51.9,0,0,1,2.09-15.59,48.65,48.65,0,0,1,22.76-28,47.23,47.23,0,0,1,19.72-5.82,48.73,48.73,0,0,1,21.48,3.3,21.83,21.83,0,0,1,2.57,1.14l2.55,1.24,2.43,1.47a20.89,20.89,0,0,1,2.38,1.58l2.3,1.72c.79.55,1.44,1.27,2.17,1.89s1.47,1.27,2.11,2l2,2.15a47.29,47.29,0,0,1,10.27,19.72,48.84,48.84,0,0,1,.57,21.32,47.82,47.82,0,0,1-8.1,18.52,48.43,48.43,0,0,1-29.95,19.23l-4.05.61c-1.34.11-2.67.15-4,.22a43.05,43.05,0,0,1-7.59-.38,48.08,48.08,0,0,1-13.14-3.75,49.49,49.49,0,0,1-9.87-5.94l.19-.18v0l.12.16-.19,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "418.275px 206.417px"
    },
    id: "el4h8ol669o2t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.52,208.82c-4.84,0-8.22-3.56-8.22-9.3s3.38-9.3,8.22-9.3,8.28,3.62,8.28,9.3S435.37,208.82,430.52,208.82Zm0-3.95c2.05,0,3.47-1.78,3.47-5.35s-1.42-5.35-3.47-5.35-3.47,1.74-3.47,5.35S428.43,204.87,430.52,204.87Zm2.9,19.46h-5.65L405,190.61h5.66Zm-25.48.39c-4.84,0-8.27-3.61-8.27-9.3s3.43-9.3,8.27-9.3,8.23,3.62,8.23,9.3S412.75,224.72,407.94,224.72Zm0-3.95c2.05,0,3.47-1.74,3.47-5.35s-1.42-5.35-3.47-5.35-3.47,1.78-3.47,5.35S405.85,220.77,407.94,220.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "419.235px 207.47px"
    },
    id: "el2r9cygn3538",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2",
    className: "animable",
    style: {
      transformOrigin: "81.4314px 374.553px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "46.85 402.58 54.99 456.08 102.29 456.08 113.27 403.35 46.85 402.58",
    style: {
      fill: "#9B6EF3",
      transformOrigin: "80.06px 429.33px"
    },
    id: "el3ha1jg4lieg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.66,436.86c0,.16-12.12.28-27.07.28s-27.07-.12-27.07-.28,12.12-.27,27.07-.27S106.66,436.71,106.66,436.86Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "79.59px 436.865px"
    },
    id: "el06hghjlhqmgh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.84,434.23c0,.16-12.2.28-27.25.28s-27.25-.12-27.25-.28,12.2-.27,27.25-.27S106.84,434.08,106.84,434.23Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "79.59px 434.235px"
    },
    id: "el2xwa7aghq1l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.75,431.26c0,.16-12.21.28-27.25.28s-27.26-.12-27.26-.28S64.44,431,79.5,431,106.75,431.11,106.75,431.26Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "79.495px 431.27px"
    },
    id: "elm6z6lef677",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.43,453A43,43,0,0,1,59,446.29a43.74,43.74,0,0,1-.91-6.83,43,43,0,0,1,1.45,6.73A43.74,43.74,0,0,1,60.43,453Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "59.26px 446.23px"
    },
    id: "elcxxhtw1xfaa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.64,452.46a55.19,55.19,0,0,1-.58-6.58,50.26,50.26,0,0,1-.31-6.59,31.28,31.28,0,0,1,.86,6.56A31.63,31.63,0,0,1,63.64,452.46Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "63.2699px 445.875px"
    },
    id: "elzozkr0w77ar",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.51,452.45a53.45,53.45,0,0,1-1.59-13.58,61.33,61.33,0,0,1,.91,6.78A62.47,62.47,0,0,1,69.51,452.45Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "68.7132px 445.66px"
    },
    id: "elow58qg5ozg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.62,452.74a34.56,34.56,0,0,1-.65-6.85,33.2,33.2,0,0,1,.21-6.88,57.74,57.74,0,0,1,.34,6.86A58.13,58.13,0,0,1,73.62,452.74Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "73.2793px 445.875px"
    },
    id: "el9g0e7s6ag9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.91,452.46a39.93,39.93,0,0,1-.5-6.5,38.83,38.83,0,0,1,.06-6.52,38.35,38.35,0,0,1,.5,6.5A37.7,37.7,0,0,1,80.91,452.46Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "80.692px 445.95px"
    },
    id: "elor1opxdbq2a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.24,452.74A39.55,39.55,0,0,1,86,446a41.34,41.34,0,0,1,.33-6.72,39.55,39.55,0,0,1,.23,6.72A41.57,41.57,0,0,1,86.24,452.74Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "86.2811px 446.01px"
    },
    id: "el3hzwcvt3meb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.23,452a42.77,42.77,0,0,1,.4-7,45,45,0,0,1,1-7,42.88,42.88,0,0,1-.4,7A44.54,44.54,0,0,1,91.23,452Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "91.9299px 445px"
    },
    id: "elo2ki3bjj41",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.66,451.32a37.06,37.06,0,0,1,2.56-11.74A54.13,54.13,0,0,1,99,445.47,52.68,52.68,0,0,1,97.66,451.32Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "98.94px 445.45px"
    },
    id: "elbu3dtc1xf9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.11,297a1.71,1.71,0,0,1-.06.26l-.22.76-.9,2.88c-.41,1.25-.89,2.79-1.39,4.58s-1.14,3.82-1.71,6.1S87.58,316.35,87,319s-1.21,5.58-1.82,8.62c-1.14,6.1-2.17,12.84-2.9,20s-1,13.95-1.11,20.15c0,3.1,0,6.05.09,8.81s.19,5.32.33,7.67.32,4.45.47,6.31.31,3.46.46,4.76.23,2.28.31,3c0,.32.05.58.06.79a.82.82,0,0,1,0,.27,1,1,0,0,1-.06-.27c0-.2-.07-.46-.12-.77q-.15-1.1-.42-3c-.18-1.3-.38-2.9-.55-4.76s-.42-4-.55-6.32-.33-4.91-.4-7.68-.12-5.71-.14-8.82c.07-6.22.37-13.06,1.07-20.2s1.78-13.9,2.94-20c.64-3,1.21-5.94,1.88-8.62s1.29-5.19,1.91-7.45,1.25-4.3,1.79-6.09,1.05-3.31,1.48-4.55.76-2.16,1-2.86l.27-.74C93.06,297.09,93.1,297,93.11,297Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "86.88px 348.19px"
    },
    id: "elqbjopjday2b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.57,330.14a17.5,17.5,0,0,1,7.35-9.29c1.17-.73,2.65-1.32,3.89-.72,1.65.8,1.79,3.12,1.29,4.89a12.9,12.9,0,0,1-5.35,7.29,10.85,10.85,0,0,1-8,2",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "90.5524px 327.153px"
    },
    id: "eldkmbxx9cfse",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7,352.5c1.22-4.61,4.9-11.18,8.73-14a5.49,5.49,0,0,1,2-1,2.27,2.27,0,0,1,2.12.46c.79.74.71,2,.48,3.06a18.59,18.59,0,0,1-13.8,13.89",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "88.209px 346.159px"
    },
    id: "eldrx28rozlpe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9,372.2a27.07,27.07,0,0,1,8.81-11.08,4.21,4.21,0,0,1,3.08-1.1c1.67.31,2.42,2.35,2.28,4-.31,3.48-3,6.27-5.71,8.44a35.54,35.54,0,0,1-8.15,4.19",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "87.9933px 368.332px"
    },
    id: "elpnmmmxo3paq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.35,386.35a26,26,0,0,1,7.49-8.53,5.38,5.38,0,0,1,2.25-1,2.3,2.3,0,0,1,2.21.84c.75,1.1,0,2.59-.77,3.66a21.34,21.34,0,0,1-10.7,7.84",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "87.4801px 382.972px"
    },
    id: "elluga1f972gk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,380.6a83.17,83.17,0,0,0-10.72-10.92c-.61-.51-1.38-1.05-2.13-.8a1.59,1.59,0,0,0-1,1.44,4,4,0,0,0,.41,1.79,20.75,20.75,0,0,0,13.8,11.6",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "74.255px 376.263px"
    },
    id: "elid2r1uq3e5o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.32,362.18,72.9,351.92a10.22,10.22,0,0,0-2.73-2.6,3.48,3.48,0,0,0-3.59,0,3.4,3.4,0,0,0-1.15,3.39A8.75,8.75,0,0,0,67.07,356a24.89,24.89,0,0,0,6.13,6.52c2.47,1.7,4.72,2.81,7.69,2.37",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "73.3313px 356.904px"
    },
    id: "elut1hvb8udod",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.49,341.44A29.35,29.35,0,0,0,74,328.72a5,5,0,0,0-2.21-1.28c-1.69-.33-3.31,1.08-3.86,2.71a6.9,6.9,0,0,0,.77,5.57,14.46,14.46,0,0,0,4,4.18A33.82,33.82,0,0,0,82,345",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "75.0734px 336.196px"
    },
    id: "elpqf2k55hrse",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.85,323c-.81-5.95-3.91-10.9-7.5-15.72-.75-1-1.81-2.09-3.06-1.9a2.44,2.44,0,0,0-1.76,1.51,5.78,5.78,0,0,0-.33,2.38,18.38,18.38,0,0,0,11.93,16.42",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "79.5176px 315.524px"
    },
    id: "el3m4936e3k0b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.21,313.51a49.69,49.69,0,0,1-.31-9.2A16.41,16.41,0,0,1,91,295.74,7.05,7.05,0,0,1,94,293.3a3.86,3.86,0,0,1,3.75.5,4.07,4.07,0,0,1,1.29,3.3,10.46,10.46,0,0,1-1,3.53c-2.24,5.39-6,11.37-9.89,12.88",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "93.4328px 303.268px"
    },
    id: "el61uq597h8o7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.53,320.6a3.39,3.39,0,0,1,0,.75c0,.55,0,1.27,0,2.16s0,2.09.06,3.42.05,2.84.16,4.52c.15,3.34.47,7.32,1,11.72s1.29,9.2,2.33,14.21,2.31,9.7,3.58,13.95,2.6,8,3.81,11.12c.57,1.58,1.17,3,1.67,4.21s.94,2.29,1.32,3.14l.84,2a5.46,5.46,0,0,1,.27.71,3.21,3.21,0,0,1-.37-.66l-.94-1.95c-.41-.84-.89-1.88-1.41-3.11s-1.15-2.61-1.75-4.18c-1.26-3.12-2.6-6.89-3.93-11.12s-2.57-9-3.63-14-1.78-9.85-2.3-14.26-.76-8.41-.86-11.77c-.09-1.68-.07-3.2-.08-4.53s0-2.48,0-3.42.06-1.61.08-2.16A5,5,0,0,1,51.53,320.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "58.9328px 356.555px"
    },
    id: "el5jrd0fi09ij",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.85,345a12.55,12.55,0,0,1,3-7.91,3,3,0,0,1,2.5-1.32c1.29.19,1.88,1.74,1.93,3.05a9.26,9.26,0,0,1-2.08,6.12,7.84,7.84,0,0,1-5,3.11",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "56.5669px 341.91px"
    },
    id: "elogqqbz069ha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.71,360.84c-.16-3.41.93-8.67,2.92-11.44a4.13,4.13,0,0,1,1.13-1.15,1.63,1.63,0,0,1,1.54-.14,2.32,2.32,0,0,1,1,2,13.31,13.31,0,0,1-6.41,12.43",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "59.017px 355.26px"
    },
    id: "elih6ibkjp3sf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.41,374.42A19.34,19.34,0,0,1,63,365a3,3,0,0,1,1.86-1.41c1.2-.15,2.16,1.07,2.42,2.26.55,2.43-.66,4.91-2.07,7a25.13,25.13,0,0,1-4.64,4.61",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "63.4128px 370.519px"
    },
    id: "el1a56vpyteep",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.76,384A18.52,18.52,0,0,1,66,376.54a3.76,3.76,0,0,1,1.31-1.17,1.63,1.63,0,0,1,1.68.09c.75.59.59,1.76.27,2.66a15.23,15.23,0,0,1-5.6,7.64",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "66.1437px 380.47px"
    },
    id: "elvkx35ezo7oh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.27,380.12A59.39,59.39,0,0,0,51.62,375a1.71,1.71,0,0,0-1.62-.09,1.12,1.12,0,0,0-.36,1.19,2.88,2.88,0,0,0,.66,1.13,14.83,14.83,0,0,0,11.89,4.93",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "55.8909px 378.466px"
    },
    id: "el9g39gbnlbi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.54,367.51l-7.94-5.18a7.33,7.33,0,0,0-2.42-1.17,2.18,2.18,0,0,0-2.51,3.29,6.34,6.34,0,0,0,1.84,1.95,17.85,17.85,0,0,0,5.58,3.11c2,.63,3.82.9,5.75,0",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "51.0654px 365.565px"
    },
    id: "elmg4lws6ts4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.87,353.14a20.87,20.87,0,0,0-8.5-6.84,3.52,3.52,0,0,0-1.78-.4,2.65,2.65,0,0,0-2.05,2.68,5,5,0,0,0,1.72,3.63,10.58,10.58,0,0,0,3.6,2,24.07,24.07,0,0,0,7.46,1.43",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "47.9291px 350.769px"
    },
    id: "el0s1zs1ghkgfb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.18,339.82c-1.83-3.87-5-6.58-8.49-9.08a2.56,2.56,0,0,0-2.49-.64,1.75,1.75,0,0,0-.88,1.41,4.13,4.13,0,0,0,.29,1.69,13.14,13.14,0,0,0,11.65,8.61",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "46.2884px 335.907px"
    },
    id: "elh62208toynb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.75,332.89a35.43,35.43,0,0,1-2.19-6.2,11.83,11.83,0,0,1,.24-6.49,5,5,0,0,1,1.56-2.32,2.76,2.76,0,0,1,2.66-.47,2.93,2.93,0,0,1,1.58,2,7.38,7.38,0,0,1,.11,2.61c-.36,4.15-1.62,9-4,10.9",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "52.4979px 325.088px"
    },
    id: "elnvdw5mjf4dq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.33,320.08a3.19,3.19,0,0,1,.07.75c0,.55,0,1.27.08,2.16s.06,2.09,0,3.42,0,2.86-.08,4.53c-.1,3.36-.38,7.35-.86,11.77s-1.26,9.24-2.3,14.26-2.33,9.74-3.63,14-2.67,8-3.94,11.12c-.59,1.57-1.22,2.95-1.74,4.18s-1,2.27-1.41,3.11-.71,1.46-.94,1.95a3.94,3.94,0,0,1-.37.66,6.17,6.17,0,0,1,.26-.71c.22-.5.5-1.16.85-2s.83-1.91,1.32-3.15,1.1-2.63,1.67-4.2c1.21-3.13,2.51-6.9,3.81-11.13s2.52-8.95,3.58-13.95,1.78-9.82,2.33-14.21.83-8.38,1-11.72c.11-1.68.12-3.19.16-4.52s.06-2.48.05-3.42,0-1.61,0-2.16A4,4,0,0,1,111.33,320.08Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "103.871px 356.035px"
    },
    id: "elfp3cyk9bwg8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,344.47a12.55,12.55,0,0,0-3-7.9,3,3,0,0,0-2.5-1.33c-1.29.19-1.88,1.74-1.93,3.05a9.26,9.26,0,0,0,2.08,6.12,7.77,7.77,0,0,0,5,3.11",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "106.283px 341.38px"
    },
    id: "el4hxrh9201g2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.16,360.32c.16-3.41-.94-8.67-2.93-11.44a4,4,0,0,0-1.12-1.15,1.66,1.66,0,0,0-1.54-.14,2.31,2.31,0,0,0-1,2A13.29,13.29,0,0,0,107,362",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "103.854px 354.731px"
    },
    id: "el9n4h8qwg14q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.46,373.9a19.29,19.29,0,0,0-3.62-9.44A3,3,0,0,0,98,363.05c-1.2-.15-2.16,1.08-2.42,2.26-.55,2.44.66,4.91,2.07,7a25.13,25.13,0,0,0,4.64,4.61",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "99.4522px 369.979px"
    },
    id: "el1ivyht9cfuo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.11,383.44A18.52,18.52,0,0,0,96.84,376a3.76,3.76,0,0,0-1.31-1.17,1.63,1.63,0,0,0-1.68.09c-.75.59-.59,1.76-.27,2.66a15.18,15.18,0,0,0,5.59,7.64",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "96.7113px 379.93px"
    },
    id: "el4f8u8jdye6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.6,379.6a59.71,59.71,0,0,1,9.64-5.12,1.73,1.73,0,0,1,1.63-.09,1.12,1.12,0,0,1,.36,1.19,2.88,2.88,0,0,1-.66,1.13,14.84,14.84,0,0,1-11.89,4.93",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "106.979px 377.945px"
    },
    id: "el7haa8xdntp5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.33,367l7.94-5.18a7.33,7.33,0,0,1,2.42-1.17,2.18,2.18,0,0,1,2.51,3.3,6.33,6.33,0,0,1-1.85,1.94,17.63,17.63,0,0,1-5.58,3.11c-2,.63-3.81.9-5.74,0",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "111.809px 365.053px"
    },
    id: "elvemsvc0lju",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,352.62a21,21,0,0,1,8.5-6.84,3.52,3.52,0,0,1,1.78-.4,2.65,2.65,0,0,1,2,2.68,5,5,0,0,1-1.72,3.63,10.58,10.58,0,0,1-3.6,2,24.07,24.07,0,0,1-7.46,1.43",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "114.891px 350.249px"
    },
    id: "el5vrw3yobuc2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.69,339.3c1.83-3.87,5-6.58,8.49-9.08a2.56,2.56,0,0,1,2.49-.64,1.73,1.73,0,0,1,.87,1.41,3.94,3.94,0,0,1-.28,1.69,13.12,13.12,0,0,1-11.66,8.61",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "116.573px 335.387px"
    },
    id: "el3bpxz3l07tq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.12,332.37a36.26,36.26,0,0,0,2.19-6.2,11.83,11.83,0,0,0-.24-6.49,5,5,0,0,0-1.56-2.32,2.76,2.76,0,0,0-2.66-.47,2.92,2.92,0,0,0-1.58,2,7.32,7.32,0,0,0-.11,2.6c.36,4.16,1.62,9,4,10.9",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "110.372px 324.563px"
    },
    id: "el2i70oedr07j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.42,392v10a3.94,3.94,0,0,0,3.95,3.94h68.49A3.94,3.94,0,0,0,117.8,402V392Z",
    style: {
      fill: "#9B6EF3",
      transformOrigin: "79.61px 398.97px"
    },
    id: "elg72ue7p6i3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljgbqgupolql",
    className: ""
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "80.045px 409.78px"
    },
    className: "animable",
    id: "elc03g5b57htp"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "47.36 405.93 47.93 409.12 111.13 413.63 112.73 405.93 47.36 405.93",
    id: "elnry3tprbrc",
    className: "animable",
    style: {
      transformOrigin: "80.045px 409.78px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calculator--inject-2",
    className: "animable",
    style: {
      transformOrigin: "422.92px 448.132px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.62,456.1h81.25l31.35-12.79v-3.2l-51.19.32-24.31,11.83-32.52-.53A4.5,4.5,0,0,0,366.62,456.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "422.92px 448.105px"
    },
    id: "ellqqfafhtwvp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.22,443.31a4.12,4.12,0,0,1-.76.07l-2.16.09-8,.26-26.3.65-12.55.26.11,0L414,453l-4.52,2.36-1.22.61c-.27.13-.42.2-.43.18a2.23,2.23,0,0,1,.39-.26l1.18-.67,4.45-2.49,15.56-8.5.05,0h.06l12.55-.29,26.3-.5,8-.09h2.17A4,4,0,0,1,479.22,443.31Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "443.525px 449.731px"
    },
    id: "ela3kvy2kfsnh",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    className: "animable",
    style: {
      transformOrigin: "279.715px 282.676px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.29,110.74c-12.84-2.79-26.6,1.52-36.88,9.71s-17.34,19.87-21.83,32.21-6.56,25.43-8.32,38.45q-4.37,32.4-6.24,65.08c-.15,2.73-.28,5.57.79,8.08,1.53,3.61,5.3,5.86,9.14,6.61s7.81.24,11.69-.28",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "262.605px 190.575px"
    },
    id: "elow09lsawp8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.23,116.18c10-.8,22.11,3,27.8,11.2,4.43,6.4,3.42,17.59,5,25.22,2.47,12.22,4.94,24.52,5.29,37,.38,13.7-1.82,27.33-4,40.86L343,275.32c-1.07,6.66-2.19,13.44-5.33,19.41S329,305.81,322.29,306.6c-6.12.72-12.28-2.34-16.41-6.92s-6.46-10.53-7.91-16.52",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "326.167px 211.39px"
    },
    id: "elyv9zviwck3j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.64,258.64c-.33-.16.16-1.91,1.27-5s2.85-7.37,4.79-12.76a119.93,119.93,0,0,0,5.36-19.14,63.68,63.68,0,0,0,0-23.77c-1.57-8.4-4.33-16.28-6.58-23.62a115.87,115.87,0,0,1-4.73-20.06,48,48,0,0,1,.09-14c.58-3.27,1.35-5,1.67-4.9.81.14-.5,7.24,1.87,18.32a151,151,0,0,0,5.66,19.17c2.47,7.19,5.45,15.19,7.15,24.16.42,2.24.71,4.49.91,6.72.08,1.12.17,2.22.17,3.33s.08,2.2,0,3.28a65.7,65.7,0,0,1-1.51,12.32,97.17,97.17,0,0,1-6.66,19.6,124.22,124.22,0,0,1-6.37,12.25C345.06,257.35,344,258.8,343.64,258.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "352.293px 197.019px"
    },
    id: "elkhpkp76vckg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.93,157c1.33-23.47,22.11-41.28,46.23-39.1C327.89,120,344.71,140,344,162.41c-.61,19.65-1.67,39.4-3.07,46.39-4.2,21.07-18.31,26.95-23.87,28.48a30,30,0,0,1-5.92.33h0a.14.14,0,0,0-.15.14l.27,25.13c-.78,16.29-12.45,28.78-29,28.09s-27-15.25-26.55-31.6Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "299.859px 204.358px"
    },
    id: "el7smq9q8jzpv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,175a3.43,3.43,0,0,1-3.48,3.31,3.34,3.34,0,0,1-3.47-3.23,3.43,3.43,0,0,1,3.48-3.31A3.33,3.33,0,0,1,335,175Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "331.525px 175.04px"
    },
    id: "elsoi4botxun9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,167.22c-.45.42-3-1.6-6.75-1.75s-6.55,1.58-6.94,1.12c-.19-.21.28-1,1.51-1.8a9.58,9.58,0,0,1,5.57-1.44,9.34,9.34,0,0,1,5.35,1.94C337.84,166.2,338.2,167,338,167.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "331.161px 165.307px"
    },
    id: "el9c3y90hqcmr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.05,174.13a3.42,3.42,0,0,1-3.47,3.31,3.33,3.33,0,0,1-3.47-3.23,3.44,3.44,0,0,1,3.47-3.31A3.33,3.33,0,0,1,300.05,174.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "296.58px 174.17px"
    },
    id: "ellhfvrvplnb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.22,166.37c-.45.43-3-1.59-6.75-1.74s-6.54,1.58-6.93,1.11c-.19-.2.27-1,1.5-1.79a9.6,9.6,0,0,1,5.57-1.45,9.29,9.29,0,0,1,5.35,1.95C301.07,165.36,301.44,166.18,301.22,166.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "294.39px 164.459px"
    },
    id: "el0nbya15dv0ar",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.79,194.18c0-.21,2.33-.5,6.11-.82,1-.06,1.87-.21,2.05-.84a4.74,4.74,0,0,0-.53-2.81q-1.23-3.45-2.56-7.26c-3.55-10.33-6.09-18.81-5.66-18.95s3.64,8.14,7.19,18.47c.85,2.55,1.67,5,2.44,7.3.33,1.08.9,2.32.36,3.7a2.37,2.37,0,0,1-1.62,1.31,6.46,6.46,0,0,1-1.62.15C316.15,194.48,313.8,194.39,313.79,194.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "318.283px 178.971px"
    },
    id: "eljbg1khiyyi8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,237.6s-14.47.56-32.13-10.85c0,0,5,19,32.21,17.62Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "294.975px 235.596px"
    },
    id: "el58si08k7y2o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.89,203a6.84,6.84,0,0,0-5.95-2.71,6.21,6.21,0,0,0-4.33,2.06,3.79,3.79,0,0,0-.45,4.37c1,1.44,3,1.85,4.85,1.42a14,14,0,0,0,4.88-2.6,4.09,4.09,0,0,0,1.11-1,1.21,1.21,0,0,0,0-1.37",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "306.44px 204.287px"
    },
    id: "elv92s86kkqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.7,196.27c.61,0,.47,4,3.84,6.95s7.71,2.72,7.72,3.28c0,.25-1,.73-2.82.7a10.24,10.24,0,0,1-6.45-2.5,8.66,8.66,0,0,1-3-5.82C301.93,197.2,302.42,196.23,302.7,196.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "308.122px 201.735px"
    },
    id: "elkbcpx8wil6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.13,160c-.4,1-4.12.36-8.52.69s-8,1.37-8.54.45c-.25-.44.4-1.36,1.87-2.26a14.3,14.3,0,0,1,6.39-1.91,14.46,14.46,0,0,1,6.61,1C302.53,158.72,303.31,159.54,303.13,160Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "294.587px 159.216px"
    },
    id: "elbb29fsra4fd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.88,159.65c-.68.81-3.23-.16-6.32-.33s-5.74.32-6.31-.58c-.25-.43.19-1.25,1.37-2a8.84,8.84,0,0,1,5.19-1.16,8.94,8.94,0,0,1,5,1.89C336.86,158.38,337.19,159.26,336.88,159.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "330.587px 157.758px"
    },
    id: "elw0f5cqxymve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.82,247.54s48.77,18.85,54.68,22.23,7.83,5.77,7.83,5.77L334.05,308H268.21l-50.37-34.33,8.78-22.34L254.7,245",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "293.085px 276.5px"
    },
    id: "elbepzxw8uwvs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.92,436.18a21,21,0,0,1-1.28-6.32,21.39,21.39,0,0,1,.16-6.44c.15,0,0,2.88.36,6.4S201.07,436.15,200.92,436.18Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "200.207px 429.8px"
    },
    id: "elzaz8vt8amqi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.33,275.54l-9,5.94-2.18,158.91,42.89-24.28S378.77,278.84,368.33,275.54Z",
    style: {
      fill: "#9B6EF3",
      transformOrigin: "378.595px 357.965px"
    },
    id: "ell0vi71k8op",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.62,251.37s-33,2.2-40.65,13.73-32.4,121.4-32.4,121.4S140.4,406.17,139.33,411c-1.45,6.51-2.79,19.52-2.79,19.52l8.21,12L148,445.8s-2.16-36.85,36.29-26.1l11-1,11-66.09,5.45,53.8L198,456.29l159.15-.09,4.34-176.12S340.72,291,318.9,288.17C306.08,286.52,245.3,270.6,226.62,251.37Z",
    style: {
      fill: "#9B6EF3",
      transformOrigin: "249.015px 353.83px"
    },
    id: "el81y53ea91v9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.24,413.07c-.05,0-.35-.77-1-2.14a28.7,28.7,0,0,0-3.44-5.42,29.19,29.19,0,0,0-7-6.33,27,27,0,0,0-22.29-3.43,29.3,29.3,0,0,0-8.61,3.93,28.48,28.48,0,0,0-4.9,4.13c-1,1.11-1.57,1.77-1.61,1.74a3.51,3.51,0,0,1,.35-.5,15.08,15.08,0,0,1,1.11-1.38,25.94,25.94,0,0,1,4.84-4.29,28.79,28.79,0,0,1,8.69-4.09A27.08,27.08,0,0,1,183,398.77a28.87,28.87,0,0,1,7.06,6.52,26.36,26.36,0,0,1,3.33,5.55,14.41,14.41,0,0,1,.64,1.64A2.16,2.16,0,0,1,194.24,413.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "169.815px 403.639px"
    },
    id: "eliz2tb2rx03",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.75,408.76a12.6,12.6,0,0,1-.35-1.64,39.13,39.13,0,0,0-1.2-4.39,33.18,33.18,0,0,0-20.3-20.68,35.81,35.81,0,0,0-4.37-1.28,11.65,11.65,0,0,1-1.63-.39,1.28,1.28,0,0,1,.43,0c.29,0,.71.07,1.24.17A30.36,30.36,0,0,1,173,381.7a32.23,32.23,0,0,1,20.53,20.92,29.94,29.94,0,0,1,1,4.47c.09.53.11,1,.14,1.24S194.77,408.76,194.75,408.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "180.827px 394.561px"
    },
    id: "elfnz7cfxadpd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.34,352.65a2.25,2.25,0,0,1-.31-.45l-.8-1.34c-.69-1.17-1.66-2.88-2.84-5-2.36-4.24-5.52-10.15-9-16.69s-6.63-12.45-9-16.68c-1.16-2.07-2.11-3.76-2.82-5-.3-.55-.55-1-.76-1.36a1.79,1.79,0,0,1-.23-.5,3.3,3.3,0,0,1,.32.44l.85,1.32c.72,1.15,1.74,2.82,3,4.93,2.45,4.19,5.67,10.07,9.14,16.61l8.85,16.77,2.69,5.07c.29.56.52,1,.72,1.39A2.05,2.05,0,0,1,206.34,352.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "193.46px 329.14px"
    },
    id: "elxquizdqru0d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.22,293.87a4.3,4.3,0,0,1,0,.78c0,.56,0,1.31,0,2.24,0,1.95,0,4.77.11,8.26.12,7,.48,16.59,1.06,27.21s1.29,20.23,1.85,27.18c.28,3.43.51,6.23.67,8.23.07.93.13,1.67.17,2.23a3.92,3.92,0,0,1,0,.79,4.63,4.63,0,0,1-.13-.78l-.27-2.22c-.22-1.94-.52-4.75-.84-8.22-.65-6.94-1.41-16.55-2-27.18s-.88-20.26-.91-27.24c0-3.48,0-6.31.05-8.26,0-.93.06-1.68.08-2.24A3.74,3.74,0,0,1,204.22,293.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "206.015px 332.33px"
    },
    id: "eljmnb4vd7yf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.61,441.33a.84.84,0,0,1-.27-.09l-.77-.31-2.94-1.25c-1.28-.54-2.84-1.22-4.62-2.08s-3.83-1.76-6-2.91l-3.47-1.77c-1.21-.62-2.43-1.32-3.71-2-2.58-1.37-5.26-3-8.09-4.64-5.61-3.41-11.66-7.36-17.78-11.83s-11.69-9.08-16.62-13.41c-2.44-2.21-4.77-4.28-6.85-6.33-1.05-1-2.08-2-3-2.94L233.7,389c-1.76-1.75-3.25-3.43-4.59-4.88s-2.47-2.72-3.37-3.78l-2.07-2.43-.53-.64A1.12,1.12,0,0,1,223,377a1.17,1.17,0,0,1,.21.2l.57.6,2.14,2.37c.93,1,2.06,2.3,3.43,3.71s2.87,3.09,4.64,4.82l2.75,2.76c1,.95,2,1.9,3,2.91,2.09,2,4.43,4.09,6.86,6.28,4.95,4.3,10.53,8.86,16.62,13.35s12.13,8.42,17.72,11.84c2.82,1.67,5.48,3.29,8,4.67,1.28.7,2.5,1.41,3.7,2l3.45,1.8c2.19,1.17,4.22,2.11,6,3s3.3,1.59,4.57,2.15l2.9,1.34.75.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "266.805px 409.165px"
    },
    id: "el5o5y3dbqhpp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.63,391.11l52.84,57.27,4,8.51L210,452.68,156.36,396a3.61,3.61,0,0,1,.33-5.27h0A3.6,3.6,0,0,1,161.63,391.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "186.921px 423.407px"
    },
    id: "elecgpa8rbtrg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.22,328.29a1.43,1.43,0,0,1,0,.3v.88c0,.81,0,1.94-.05,3.38-.07,3-.17,7.2-.3,12.42-.25,10.51-.6,25-1,41s-.54,30.46-.73,41c-.09,5.22-.17,9.45-.22,12.42,0,1.44-.07,2.57-.09,3.38q0,.54,0,.87a.15.15,0,1,1-.06,0c0-.22,0-.51,0-.87,0-.81,0-1.94,0-3.38,0-3,0-7.21.06-12.42.08-10.49.24-25,.58-41s.78-30.48,1.13-41c.2-5.22.35-9.45.46-12.42.07-1.43.12-2.56.16-3.37l.05-.88A1.4,1.4,0,0,1,359.22,328.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "357.939px 386.263px"
    },
    id: "eltnxs5p35wo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elz3m0imfuok"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "270.687px 409.057px"
    },
    className: "animable",
    id: "el3ncnm060yhr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.81,382.54s24,16.61,37.6,22,27.56,9.87,40.65,16.34c3.84,1.9,8.2,5.13,7.41,9.34-.48,2.57-2.91,4.43-5.45,5.05a20.7,20.7,0,0,1-7.8-.14l-3.35-.21S254.3,413.07,227.81,382.54Z",
    id: "el9enob33zaw",
    className: "animable",
    style: {
      transformOrigin: "270.687px 409.057px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M390.7,397.75a16.22,16.22,0,0,1-1.79.25,41.59,41.59,0,0,0-4.84.94,37.72,37.72,0,0,0-24.57,19.69,40.45,40.45,0,0,0-2,4.52,15.62,15.62,0,0,1-.64,1.7,1.47,1.47,0,0,1,.08-.46c.08-.3.18-.75.37-1.3a33.29,33.29,0,0,1,1.83-4.62A36.72,36.72,0,0,1,384,398.58a34,34,0,0,1,4.9-.78c.59-.06,1-.05,1.35-.07A1.7,1.7,0,0,1,390.7,397.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "373.78px 411.287px"
    },
    id: "elkbzksvuas7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ela3zn66aq4q4"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "372.02px 408.313px"
    },
    className: "animable",
    id: "elu4xst1vpg9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.81,423.56a38,38,0,0,1,23.31-29.87,8,8,0,0,1,4.32-.75,3.22,3.22,0,0,1,2.79,3c-.06,2.16-2.67,3.11-4.72,3.76-5.7,1.81-10.66,5.49-14.8,9.8a108.41,108.41,0,0,0-10.88,14.23",
    id: "elz9s9iljgllp",
    className: "animable",
    style: {
      transformOrigin: "372.02px 408.313px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el7fg0n0w0fw4"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "178.695px 398.173px"
    },
    className: "animable",
    id: "eli89gjegogeh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.15,413.85a36,36,0,0,0-23.74-30.59,11.56,11.56,0,0,0-4.78-.78,5,5,0,0,0-4,2.47c-.92,1.87-.11,4.23,1.38,5.68a14.08,14.08,0,0,0,5.5,2.87c5.59,1.88,11.43,3.48,16.19,7s6.18,7.72,9.43,13.38",
    id: "el266qu8gafh5",
    className: "animable",
    style: {
      transformOrigin: "178.695px 398.173px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M374.93,288l-.44.27-1.33.76L371,290.24c-.86.47-1.84,1-3,1.58A135,135,0,0,1,348,300l-3.34,1.06-3.54.95c-1.2.31-2.42.68-3.69.95l-3.86.83-2,.43-2,.34-4.17.69c-1.41.21-2.86.35-4.32.53s-2.94.37-4.44.45l-4.57.32-4.69.13-2.38,0-2.41-.05c-1.61-.06-3.24,0-4.88-.16a140.89,140.89,0,0,1-20.15-2.58A149.17,149.17,0,0,1,258,298.47c-6.21-2.15-12.09-4.51-17.65-6.83-11.11-4.68-21-9.1-29.53-12.38s-15.48-5.72-20.52-6.46a31,31,0,0,0-5.84-.39c-.67,0-1.17.06-1.52.09s-.52,0-.52,0a14.42,14.42,0,0,1,2-.22,28.84,28.84,0,0,1,5.87.29c5.08.69,12.11,3.09,20.63,6.32s18.46,7.63,29.57,12.28c5.57,2.3,11.44,4.65,17.63,6.79a149.7,149.7,0,0,0,19.52,5.43A141.06,141.06,0,0,0,297.74,306c1.63.12,3.26.11,4.86.16l2.4.06,2.37,0,4.67-.12,4.56-.31c1.5-.08,3-.26,4.43-.43s2.89-.32,4.31-.52l4.15-.68,2-.33,2-.42,3.86-.82c1.26-.26,2.48-.63,3.68-.93l3.53-.93,3.34-1a140.87,140.87,0,0,0,20-8c1.17-.52,2.15-1.08,3-1.54l2.19-1.17,1.35-.7Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "278.675px 289.46px"
    },
    id: "el9j8l7ri6ok5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,307.36a5.79,5.79,0,0,1-1.09-.59L199.49,305a71.64,71.64,0,0,0-9.81-5.16,32.32,32.32,0,0,0-10.7-2.51c-2.84-.12-4.58.25-4.59.14a5.13,5.13,0,0,1,1.21-.27A19.34,19.34,0,0,1,179,297a30.06,30.06,0,0,1,10.89,2.4,60,60,0,0,1,9.81,5.33c1.19.78,2.14,1.43,2.79,1.89A5.6,5.6,0,0,1,203.46,307.36Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "188.925px 302.176px"
    },
    id: "elswrk0mfk5bo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.92,333.33l-.36.2-1.09.57-1.77.89-2.46,1.12a90.24,90.24,0,0,1-16.39,5.34,114.79,114.79,0,0,1-25.41,2.75A162.87,162.87,0,0,1,281.3,341c-10.92-2.11-21.14-5-30.36-7.7s-17.46-5.45-24.35-7.82-12.41-4.4-16.21-5.84L206,317.94l-1.13-.46a2.24,2.24,0,0,1-.38-.17,2.08,2.08,0,0,1,.4.12l1.15.41,4.41,1.59c3.82,1.38,9.37,3.36,16.26,5.68s15.14,5,24.37,7.71,19.43,5.55,30.32,7.65a164.54,164.54,0,0,0,31,3.25,115.92,115.92,0,0,0,25.33-2.63,95.23,95.23,0,0,0,16.39-5.16l2.48-1.08,1.79-.85,1.1-.51A1.57,1.57,0,0,1,359.92,333.33Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "282.205px 330.755px"
    },
    id: "elookoa3tkc3r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.3,317.2a28.54,28.54,0,0,1-3.4,1c-2.11.6-5,1.48-8.13,2.69s-5.85,2.51-7.82,3.49a27.31,27.31,0,0,1-3.21,1.53,3.49,3.49,0,0,1,.79-.55c.52-.33,1.29-.78,2.25-1.31a66.57,66.57,0,0,1,7.8-3.65,67.73,67.73,0,0,1,8.22-2.56c1.07-.26,1.95-.44,2.55-.55A4.19,4.19,0,0,1,381.3,317.2Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "370.02px 321.555px"
    },
    id: "el8lr18v24stl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.35,351.47a10.52,10.52,0,0,1-1.43-.92c-.45-.31-1-.69-1.66-1.09s-1.38-.91-2.24-1.37A63.12,63.12,0,0,0,193,345a60.89,60.89,0,0,0-16-4.66,63.59,63.59,0,0,0-6.8-.62c-1-.06-1.85,0-2.63,0s-1.44,0-2,0a9.28,9.28,0,0,1-1.7,0,12.69,12.69,0,0,1,1.69-.2c.54-.06,1.21-.11,2-.12s1.66-.08,2.64,0a57.37,57.37,0,0,1,6.86.51,65.1,65.1,0,0,1,8.24,1.76,61.48,61.48,0,0,1,7.89,2.95,53.12,53.12,0,0,1,6.06,3.25c.85.49,1.57,1,2.21,1.45s1.19.83,1.62,1.17A11.23,11.23,0,0,1,204.35,351.47Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "184.11px 345.416px"
    },
    id: "elroajz6wi4a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.81,378.27l-.38.13-1.12.31c-1,.25-2.44.7-4.34,1.12a139.23,139.23,0,0,1-16.26,2.79,166.24,166.24,0,0,1-24.44.92,231.37,231.37,0,0,1-29.79-3.06c-21-3.5-39.5-9-52.81-13-6.66-2-12-3.75-15.73-4.94l-4.26-1.39-1.11-.38-.37-.14a1.74,1.74,0,0,1,.39.09l1.12.33,4.29,1.29,15.77,4.79c13.34,3.94,31.84,9.34,52.79,12.84a238.14,238.14,0,0,0,29.73,3.09,172.79,172.79,0,0,0,24.38-.8,150.91,150.91,0,0,0,16.25-2.63c1.91-.38,3.36-.8,4.36-1l1.14-.26Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "282.505px 372.139px"
    },
    id: "elgmr84q4rhi6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.86,351.78a6.89,6.89,0,0,1-1.21.29l-3.34.67c-2.8.59-6.66,1.53-10.83,2.85s-7.85,2.8-10.48,3.94l-3.11,1.38a5.52,5.52,0,0,1-1.16.46,6.09,6.09,0,0,1,1.07-.65c.71-.39,1.75-.91,3.05-1.53a86.95,86.95,0,0,1,21.39-6.81c1.42-.25,2.57-.42,3.37-.51A5.58,5.58,0,0,1,388.86,351.78Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "373.795px 356.573px"
    },
    id: "elenvcdhb805t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.72,391.8a19,19,0,0,1-1.07-1.66,40.17,40.17,0,0,0-3.15-4.31,37.8,37.8,0,0,0-31.09-13.61,40,40,0,0,0-5.31.6,18.6,18.6,0,0,1-1.94.34,2.12,2.12,0,0,1,.48-.17c.33-.08.8-.24,1.42-.37a34.22,34.22,0,0,1,5.33-.77,36.89,36.89,0,0,1,31.39,13.75,35,35,0,0,1,3.05,4.44c.32.54.53,1,.69,1.29A1.56,1.56,0,0,1,199.72,391.8Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "178.44px 381.78px"
    },
    id: "ele86ek7brl8l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.17,415c0,.14-11.46-1.86-25.55-4.47s-25.48-4.83-25.45-5,11.46,1.86,25.55,4.46S263.2,414.89,263.17,415Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "237.67px 410.263px"
    },
    id: "eldiqmrlpw4om",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,424.09a4.72,4.72,0,0,1-.81.07l-2.32.11c-2,.09-4.92.18-8.53.26-7.2.16-17.16.22-28.15,0s-20.94-.74-28.13-1.22c-3.6-.23-6.51-.45-8.51-.63l-2.31-.21a4.11,4.11,0,0,1-.81-.11,7.08,7.08,0,0,1,.81,0l2.32.11,8.52.47c7.19.38,17.13.81,28.12,1.05s20.94.24,28.14.17l8.53-.09h2.32A4.22,4.22,0,0,1,356,424.09Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "316.215px 423.511px"
    },
    id: "ellobtjw0b0sh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.74,389.07a8.15,8.15,0,0,1-1.58.06c-1,0-2.49,0-4.3.15s-4,.32-6.33.68a65.9,65.9,0,0,0-15,4.21c-2.21.93-4.17,1.85-5.77,2.71S359.9,398.46,359,399a9.71,9.71,0,0,1-1.38.77,9.19,9.19,0,0,1,1.27-.94c.83-.59,2.09-1.37,3.68-2.27a59.7,59.7,0,0,1,5.75-2.82,63.94,63.94,0,0,1,7.42-2.61,65.94,65.94,0,0,1,7.68-1.63,57.44,57.44,0,0,1,6.38-.58c1.83-.06,3.31-.05,4.32,0A8.08,8.08,0,0,1,395.74,389.07Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "376.68px 394.324px"
    },
    id: "elyfbqdara13",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.89,419.47s-.44-.82-1.33-2.24a22.52,22.52,0,0,0-4.67-5.26,27.55,27.55,0,0,0-9.15-5,31.12,31.12,0,0,0-12.66-1.3,39.94,39.94,0,0,0-12.27,3.55,54.22,54.22,0,0,0-9,5.37c-2.43,1.76-4.29,3.32-5.55,4.43-.64.54-1.11,1-1.45,1.27a4.26,4.26,0,0,1-.52.43,2.57,2.57,0,0,1,.45-.5c.32-.31.77-.79,1.39-1.35a62.27,62.27,0,0,1,5.46-4.58,52.4,52.4,0,0,1,9-5.5A39.51,39.51,0,0,1,167,405.2a31.36,31.36,0,0,1,12.86,1.36,27.46,27.46,0,0,1,9.24,5.13,21.25,21.25,0,0,1,4.6,5.43,14.93,14.93,0,0,1,.9,1.73A2.68,2.68,0,0,1,194.89,419.47Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "166.59px 412.878px"
    },
    id: "el7re3v5cnhow",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.64,456.2h-.28l-.81,0-3.13-.21c-2.72-.17-6.65-.51-11.5-1s-10.61-1.19-17-2.11-13.37-2.11-20.66-3.57-14.2-3.12-20.43-4.74-11.81-3.28-16.45-4.77c-2.33-.71-4.41-1.44-6.25-2s-3.41-1.17-4.69-1.65L205.51,435l-.76-.3-.25-.11.27.06.78.25,3,1c1.29.45,2.87,1,4.71,1.56s3.93,1.29,6.27,2c4.65,1.44,10.23,3,16.46,4.66s13.13,3.21,20.41,4.69,14.26,2.64,20.63,3.61,12.12,1.68,17,2.21,8.76.93,11.47,1.17l3.13.3.81.09Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "257.07px 445.395px"
    },
    id: "elunzuk8p8ymc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.76,415.11l14.13,4.53,5.26-.9,8.9,2.45a6.58,6.58,0,0,1,4.81,6.87,38.74,38.74,0,0,1-1.21,6.89c-2.17,8.25-5.8,8.07-9.6,7s-5.56-4.19-5.86-9.07l-9-4.92Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "200.321px 428.792px"
    },
    id: "elttsunfd36na",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.08,433.1a9.46,9.46,0,0,1-3.47-4.23,9.31,9.31,0,0,1-1-5.37,24.48,24.48,0,0,0,1.49,5.15A25.77,25.77,0,0,0,200.08,433.1Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "197.815px 428.3px"
    },
    id: "el1mxzd4dili2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.78,414.21s-11.63,1.44-14.88,7-7.15,21.27-7.15,21.27l11,12.9s44.73,1.86,46.13,0-.49-3.91-.49-3.91,5.5,2.47,7.83.84,3-5.73,2.29-7.73c-1.43-3.75-4.07-7.5-10.12-10.36S184,423.75,184,423.75s-8.37-8.37-10-9.54S166.78,414.21,166.78,414.21Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "178.265px 434.948px"
    },
    id: "eltbif30e8pkf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.41,451.47a1.86,1.86,0,0,1-.48-.12l-1.33-.45-4.87-1.75c-4.11-1.49-9.77-3.58-16-5.93-3.11-1.16-6.13-2.46-8.3-4.47a21.9,21.9,0,0,1-4.59-6.2,47,47,0,0,1-2.11-4.73c-.22-.58-.39-1-.49-1.32a1.57,1.57,0,0,1-.14-.48s.1.14.23.44.35.77.58,1.28c.51,1.11,1.22,2.73,2.25,4.64a22.23,22.23,0,0,0,4.59,6c2.11,1.93,5,3.19,8.16,4.34,6.24,2.35,11.88,4.5,16,6.08l4.81,1.9,1.3.54A1.74,1.74,0,0,1,201.41,451.47Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "182.255px 438.745px"
    },
    id: "elueva7c9qke",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.1,456.29a11,11,0,0,1-2.29-1c-1.38-.67-3.26-1.65-5.27-2.84s-3.78-2.36-5-3.25a10.89,10.89,0,0,1-1.94-1.55,12.78,12.78,0,0,1,2.14,1.24c1.29.81,3.08,1.93,5.08,3.11s3.85,2.22,5.18,3A12.8,12.8,0,0,1,178.1,456.29Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "170.85px 451.97px"
    },
    id: "elzvqsrt74dvl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.7,446.66s-.25-.32,0-1a10.7,10.7,0,0,1,1.46-2.13,2.24,2.24,0,0,0,.38-1.56,7.25,7.25,0,0,0-.62-1.86,20,20,0,0,1-1.44-4.5,8.72,8.72,0,0,1,.44-4.72,5.44,5.44,0,0,1,2.62-2.87,4.36,4.36,0,0,1,2.57-.45,1.71,1.71,0,0,1,.91.3s-.33-.07-.92-.1a4.51,4.51,0,0,0-2.39.58,5.16,5.16,0,0,0-2.34,2.72,8.26,8.26,0,0,0-.37,4.46,20.71,20.71,0,0,0,1.36,4.39,7.49,7.49,0,0,1,.61,2,2.52,2.52,0,0,1-.51,1.8,15,15,0,0,0-1.57,2A2.28,2.28,0,0,0,153.7,446.66Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "156.678px 437.096px"
    },
    id: "elrw5p6kr5tq8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.71,426.35a12.36,12.36,0,0,0-7.18,7.19,3.35,3.35,0,0,1,.35-1.54,9.25,9.25,0,0,1,2.1-3.2,9.37,9.37,0,0,1,3.19-2.1A3.35,3.35,0,0,1,179.71,426.35Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "176.12px 429.945px"
    },
    id: "el41gy9nxdqys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.3,442.34s-.21.15-.64.29a7,7,0,0,1-1.89.33,8.39,8.39,0,0,1-8.82-7.59,7.29,7.29,0,0,1,0-1.93,1.88,1.88,0,0,1,.19-.68c.1,0-.11,1,.13,2.56a8.45,8.45,0,0,0,8.45,7.27A23.85,23.85,0,0,0,211.3,442.34Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "205.593px 437.867px"
    },
    id: "el8bufvajs0e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.58,427.75l23.5-15a20.32,20.32,0,0,1,5.6,0,6.18,6.18,0,0,1,4,2.91l5.37.45,14.11,12.76,7.35,1.12,1.38,2.68-2.69,10.19s-6.72,6.86-11.64,4.16l-6.27.63-5.59-.63s.44,5.35-1.57,5.35-5.37-.67-6.27-2.24a54.29,54.29,0,0,1-2.46-6.26l-5.37,5.59s-5,5.41-7.84,2.91c-2.43-2.11-2.69-3.35-2.69-3.35h0s-4,.67-6.25-.68-5.83-.67-6.73-5.48S357.22,430.53,361.58,427.75Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "390.026px 432.793px"
    },
    id: "elnlilnv5jdjp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.72,447.47a3.82,3.82,0,0,1-.46-.92,19.43,19.43,0,0,1-.83-2.67,81.68,81.68,0,0,1-1.28-9.11,25.41,25.41,0,0,0-2.4-8.72,29,29,0,0,0-2.07-3.15s.31.21.76.69a12.64,12.64,0,0,1,1.63,2.29,23.29,23.29,0,0,1,2.6,8.83c.42,3.57.63,6.8,1.12,9.09S387.8,447.44,387.72,447.47Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "384.204px 435.185px"
    },
    id: "eljf31otwub3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.64,425.08c.08,0-.37,1.26-.93,3.3a45.47,45.47,0,0,0-1.44,8.1,46.23,46.23,0,0,0,.1,8.22c.22,2.1.47,3.39.38,3.41a3.38,3.38,0,0,1-.27-.89,23,23,0,0,1-.47-2.47,37.21,37.21,0,0,1,1.35-16.47,23.47,23.47,0,0,1,.86-2.37A3,3,0,0,1,398.64,425.08Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "397.142px 436.595px"
    },
    id: "elohgb5bnxiil",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.73,436.58a9.62,9.62,0,0,0-2.31,1.47,9.49,9.49,0,0,0-1.42,2.34c-.07,0-.12-.34,0-.87a4.13,4.13,0,0,1,2.85-2.91C399.38,436.47,399.72,436.51,399.73,436.58Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "397.829px 438.453px"
    },
    id: "elmvgcyzmti2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.75,429.89a34.35,34.35,0,0,1-2.32,3.57,32.29,32.29,0,0,1-2.35,3.55,12.46,12.46,0,0,1,1.91-3.84A12,12,0,0,1,403.75,429.89Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "401.415px 433.45px"
    },
    id: "eljr83x2p4qt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.08,431.29c0,.13-1.36-.52-2.1-2.06a3.53,3.53,0,0,1-.34-2.93,17.46,17.46,0,0,0,.8,2.7A18.43,18.43,0,0,0,402.08,431.29Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "400.773px 428.803px"
    },
    id: "el63tvc38s57n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.54,447.12a22.93,22.93,0,0,1,2.12-2.13,15.21,15.21,0,0,0,4-5.86,14.8,14.8,0,0,0,.32-7.06,28.4,28.4,0,0,1-.45-3,12.76,12.76,0,0,1,.81,2.91,13.89,13.89,0,0,1-.18,7.29,14.33,14.33,0,0,1-4.21,6A13.6,13.6,0,0,1,407.54,447.12Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "411.141px 438.095px"
    },
    id: "elof1zjqm70if",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.23,445.41s-.47-.31-.91-1.09a5.68,5.68,0,0,1,.73-6.49c.59-.66,1.09-.9,1.13-.85s-.36.41-.84,1.08a6.16,6.16,0,0,0-.69,6.1C415,444.93,415.3,445.35,415.23,445.41Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "414.903px 441.192px"
    },
    id: "el7lnxd0fvgd5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.2,437.66a33.48,33.48,0,0,0,2.33-5.86,34.33,34.33,0,0,0,.66-6.27,5.22,5.22,0,0,1,.29,1.86,15.55,15.55,0,0,1-.45,4.53,15.89,15.89,0,0,1-1.7,4.23A5.34,5.34,0,0,1,378.2,437.66Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "379.849px 431.595px"
    },
    id: "el6u2hmbjv1ok",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.73,436.14a13.5,13.5,0,0,1-.8-3.68,13.71,13.71,0,0,1-.28-3.75,14,14,0,0,1,.8,3.68A14.19,14.19,0,0,1,376.73,436.14Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "376.188px 432.425px"
    },
    id: "elb0ucqf5iv94",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.41,450.26a8.5,8.5,0,0,0,1.76-2.71,7.19,7.19,0,0,0,.39-3.43,6.29,6.29,0,0,0-1.9-3.7c-1.09-1.06-2.36-1.88-3.37-2.81a20.92,20.92,0,0,1-2.48-2.64,18,18,0,0,1-1.38-2,2.65,2.65,0,0,1-.39-.8c.07,0,.73,1,2,2.58a24.86,24.86,0,0,0,2.52,2.52c1,.89,2.26,1.68,3.41,2.8a6.55,6.55,0,0,1,2,4,7.26,7.26,0,0,1-.51,3.63,6.11,6.11,0,0,1-1.38,2A2,2,0,0,1,379.41,450.26Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "377.029px 441.215px"
    },
    id: "el9o5ccdq1kvq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.28,443.4c0,.08-.44.27-1.09.71a6.21,6.21,0,0,0-2.77,5.15,10.36,10.36,0,0,1,0,1.3,2.26,2.26,0,0,1-.38-1.29A5.62,5.62,0,0,1,374,443.8C374.74,443.41,375.26,443.34,375.28,443.4Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "373.149px 446.971px"
    },
    id: "elmb451uy099",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.75,144.66c-8.67,16.7-9.65,36.28-9,55.09s2.84,37.79-.24,56.36c-1.21,7.3-3.23,14.69-2.07,22,.67,4.3,2.42,8.36,3.31,12.62s.77,9.07-1.9,12.51-7.55,4.77-11.86,4-8.11-3.44-11.15-6.6c-6.63-6.91-10.11-16.36-11.42-25.85s-.63-19.13.06-28.68q2.7-37.28,5.38-74.54c.78-10.74,1.61-21.73,6-31.59,4.53-10.29,12.74-18.74,22.41-24.48,11.57-6.88,26.54-9.87,38.47-3.63,4,2.09,7.81,6.08,6.86,10.47-.74,3.47-4.13,5.62-7.21,7.38l-30.53,17.37",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "280.711px 207.957px"
    },
    id: "elpv42ipvubwh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.36,278.85c-.33-.17.31-2.1,1.61-5.47s3.24-8.22,5.25-14.29a96.73,96.73,0,0,0,4.65-21.67c.76-8.24-.33-17.4-2.06-27s-3.73-19-4.32-27.77a67.83,67.83,0,0,1,2.1-23.26,38,38,0,0,1,7.21-14.06c.63-.7,1.19-1.3,1.69-1.82a15.8,15.8,0,0,1,1.38-1.17c.78-.6,1.25-.85,1.37-.72s-.08.62-.59,1.43l-1,1.45c-.35.59-.76,1.26-1.24,2a45.38,45.38,0,0,0-5.28,13.78,72.4,72.4,0,0,0-.89,22c.8,8.3,2.9,17.44,4.67,27.24s2.79,19.56,1.7,28.41a85.36,85.36,0,0,1-6,22.48,108.17,108.17,0,0,1-6.89,13.9C271.91,277.4,270.67,279,270.36,278.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "279.774px 210.223px"
    },
    id: "elb99fh6zzv5a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.64,154.55a4.64,4.64,0,0,1,.8-.3l2.32-.75c1-.31,2.25-.71,3.68-1.2s3.05-1,4.83-1.69c3.57-1.27,7.77-2.92,12.38-4.9s9.58-4.35,14.71-7,9.86-5.5,14.11-8.16,8-5.23,11-7.46c1.56-1.08,2.91-2.14,4.12-3s2.24-1.69,3.07-2.35l1.93-1.49a6.46,6.46,0,0,1,.7-.5,4.6,4.6,0,0,1-.63.58l-1.88,1.57c-.81.68-1.81,1.51-3,2.42s-2.54,2-4.08,3.11c-3.05,2.27-6.77,4.84-11,7.56s-9,5.5-14.13,8.22-10.14,5-14.76,7S255,149.73,251.39,151c-1.78.65-3.43,1.15-4.86,1.61s-2.69.84-3.71,1.13l-2.35.65A4.74,4.74,0,0,1,239.64,154.55Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "276.465px 135.15px"
    },
    id: "elraqz54ez9o8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.43,158.28a4.65,4.65,0,0,1,.85-.17l2.47-.37,1.78-.25,2.11-.38c1.51-.29,3.24-.55,5.12-1l3-.67c1-.24,2.08-.56,3.18-.85,2.21-.55,4.51-1.33,6.95-2.1a137.58,137.58,0,0,0,15.36-6.32,137.41,137.41,0,0,0,14.39-8.3c2.1-1.46,4.12-2.81,5.91-4.21.9-.7,1.79-1.34,2.61-2l2.34-1.94c1.51-1.2,2.78-2.41,3.93-3.42l1.59-1.44,1.29-1.25c.75-.73,1.35-1.31,1.8-1.73a6,6,0,0,1,.65-.58,6,6,0,0,1-.58.65l-1.73,1.8L311.14,125c-.47.46-1,.94-1.56,1.47-1.14,1-2.39,2.27-3.9,3.5l-2.32,2c-.81.68-1.7,1.33-2.6,2-1.78,1.43-3.8,2.79-5.9,4.27a132.77,132.77,0,0,1-14.43,8.37A133.91,133.91,0,0,1,265,152.93c-2.45.76-4.77,1.52-7,2.06-1.11.28-2.17.59-3.2.82l-3,.64c-1.89.44-3.63.68-5.14,1-.76.12-1.47.25-2.12.34l-1.79.21-2.48.27C239.73,158.27,239.43,158.29,239.43,158.28Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "277.095px 139.791px"
    },
    id: "eldrkg6coj5h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.13,289.35s0-.11-.07-.34-.09-.58-.16-1c-.13-.89-.34-2.2-.51-3.89a127.58,127.58,0,0,1-.76-14.39c0-6.09.35-13.34,1.1-21.35s1.82-16.79,2.86-26c2.16-18.43,4.11-35.11,5.53-47.22.72-6,1.32-10.89,1.73-14.3.21-1.66.38-3,.5-3.88,0-.42.1-.76.14-1a1.48,1.48,0,0,1,.06-.34,1.33,1.33,0,0,1,0,.35c0,.25-.05.59-.09,1-.1.92-.23,2.23-.4,3.9-.37,3.41-.91,8.29-1.57,14.32-1.38,12.11-3.27,28.79-5.37,47.23-1.05,9.22-2.13,18-2.9,26S253,263.65,253,269.73a140.93,140.93,0,0,0,.59,14.37c.14,1.69.32,3,.42,3.89,0,.42.08.76.11,1A1.33,1.33,0,0,1,254.13,289.35Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "258.595px 222.495px"
    },
    id: "elebv60dgayy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.21,233.81a4.7,4.7,0,0,1-.09-.84c0-.59-.09-1.4-.16-2.41-.12-2.09-.26-5.12-.4-8.87-.27-7.49-.47-17.85-.31-29.3s.64-21.8,1.12-29.28c.24-3.74.46-6.77.65-8.86.09-1,.16-1.8.22-2.4a4.4,4.4,0,0,1,.11-.84,4.28,4.28,0,0,1,0,.85l-.12,2.41c-.12,2.14-.28,5.16-.48,8.86-.39,7.49-.81,17.83-1,29.27s0,21.79.16,29.28c.1,3.71.18,6.73.24,8.87,0,1,0,1.82.05,2.42A6.74,6.74,0,0,1,267.21,233.81Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "267.282px 192.41px"
    },
    id: "el4cxv84qjmck",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxInvoices);
export default __webpack_public_path__ + "static/media/TaxInvoices.6630b07f.svg";
export { ForwardRef as ReactComponent };